/// <summary name='cafm.hd'>Container object for CAFM Helpdesk code</summary>
cafm.hd = {
    /// <field name='role' type='cafm.enums.RoleType'>Current role type</field>
    role: null,
    /// <field name='workOrder' type='kendo.Observable'>The active work order</field>
    workOrder: null,
    /// <field name="workOrderContext" type="cafm.hd.WorkOrderClientContext">The work order context</param>
    workOrderContext: null,
    workOrderOldValues: null,
    syncInProgress: false,
    init: function (e) {
        /// <summary>Initialises the helpdesk module</summary>
        
        // set current module to helpdesk
        cafm.setCurrentModule(cafm.enums.CAFMModuleEnum.Helpdesk);

        // setup the helpdesk url router
        cafm.nav.router = new cafm.router.Router({
            pathName: window.location.pathname,
            routes: cafm.hd.nav.routes(),
            processOnInit: true,
            cache: true,
            routeKey: e.route ? e.route.routeKey : null,
            routeArgs: e.route ? e.route.routeArgs : null
        });

        // handle searches
        cafm.handlers.set('cafm.search', cafm.hd.topLevelSearch);

        // handle logout
        cafm.handlers.set('cafm.logout', cafm.hd.logOutHandle);

        // handle back button clicks
        if (cafm.isMobile()) {
            cafm.handlers.set('cafm.back', cafm.hd.nav.backBtnHandle);
        }

        // set the portering work order type id
        var cs = cafm.getClientSettings();

        // set role ID
        if (cs.helpdeskSettings) {
            cafm.hd.role = cs.helpdeskSettings.role;
        }

        // set portering wo type ID
        cafm.hd.setPorteringWorkOrderTypeId(cs.porteringWorkOrderTypeId);
    },
    nav: {

        routes: () => {
            return {
                HelpdeskNewWorkOrder: {
                    path: 'newWorkOrder',
                        handler: function(e) {
                            cafm.hd.nav.showEditWorkOrder(e.args);
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onEditWorkOrderPreRouteChange(e); },
                    fixedScrollbar: true,
                    documentTitle: "Helpdesk"
                },
                HelpdeskNewWorkOrderForAsset: {
                    path: 'newAssetWorkOrder/{assetId}',
                        handler: function(e) {
                            cafm.hd.nav.showEditWorkOrder(e.args);
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onEditWorkOrderPreRouteChange(e); },
                    fixedScrollbar: true,
                    documentTitle: "Helpdesk"
                },
                HelpdeskNewWorkOrderForLocality: {
                    path: 'newLocalityWorkOrder/{localityId}',
                    handler: function (e) {
                        cafm.hd.nav.showEditWorkOrder(e.args);
                    },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onEditWorkOrderPreRouteChange(e); },
                    fixedScrollbar: true,
                    documentTitle: "Helpdesk"
                },
                HelpdeskNewWorkOrderForSwo: {
                    path: 'newSwoWorkOrder/{swoId}',
                        handler: function (e) {
                            cafm.hd.nav.showEditWorkOrder(e.args);
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onEditWorkOrderPreRouteChange(e); },
                    fixedScrollbar: true,
                    documentTitle: "Helpdesk"
                },
                HelpdeskViewVirtualWorkOrderForAsset: {
                    path: 'viewVirtualWorkOrderForAsset/{assetId}/{virtualWorkOrderKey}',
                        handler: function (e) {
                            cafm.hd.nav.showEditWorkOrder(e.args);
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onEditWorkOrderPreRouteChange(e); },
                    fixedScrollbar: true,
                    documentTitle: "Helpdesk"
                },
                HelpdeskViewVirtualWorkOrder: {
                    path: 'viewVirtualWorkOrder/{virtualWorkOrderKey}',
                        handler: function (e) {
                            cafm.hd.nav.showEditWorkOrder(e.args);
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onEditWorkOrderPreRouteChange(e); },
                    fixedScrollbar: true,
                    documentTitle: "Helpdesk"
                },
                HelpdeskEditWorkOrder: {
                    path: 'editWorkOrder/{workOrderId}',
                        handler: function (e) {

                            cafm.hd.nav.showEditWorkOrder(e.args);
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onEditWorkOrderPreRouteChange(e); },
                    fixedScrollbar: true,
                    documentTitle: "Helpdesk"
                },
                HelpdeskConfirmWorkOrder: {
                    path: 'confirmWorkOrder/{workOrderId}',
                        noCache: true,
                            handler: function (e) {

                                e.args.confirmation = true;
                                cafm.hd.nav.showEditWorkOrder(e.args);
                            },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onEditWorkOrderPreRouteChange(e); },
                    fixedScrollbar: true,
                    documentTitle: "Helpdesk"
                },
                HelpdeskCopyWorkOrder: {
                    path: 'copyWorkOrder/{workOrderId}',
                        noCache: true,
                            handler: function (e) {

                                e.args.copy = true;
                                cafm.hd.nav.showEditWorkOrder(e.args);
                            },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onEditWorkOrderPreRouteChange(e); },
                    fixedScrollbar: true,
                    documentTitle: "Helpdesk"
                },
                HelpdeskPendingSignatures: {
                    path: 'pendingSignatures',
                        handler: function () {

                            cafm.hd.nav.showPendingSignatures(this.path);
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    documentTitle: "Helpdesk"
                },
                HelpdeskMyWorkOrders: {
                    path: 'myWorkOrders',
                        handler: function () {

                            cafm.hd.nav.showWorkOrders({
                                action: this.path
                            });
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskAllWorkOrders: {
                    path: 'allWorkOrders',
                        handler: function (e) {
                            cafm.hd.nav.showWorkOrders({
                                action: this.path
                            });
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskMyJobs: {
                    path: 'myJobs',
                        handler: function (e) {
                            cafm.hd.nav.showWorkOrders({
                                action: this.path
                            });
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskRecentJobs: {
                    path: 'recentJobs',
                        handler: function (e) {
                            cafm.hd.nav.showWorkOrders({
                                action: this.path
                            });
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskInactiveJobs: {
                    path: 'inactiveJobs',
                        handler: function (e) {
                            cafm.hd.nav.showWorkOrders({
                                action: this.path
                            });
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskUnassignedJobs: {
                    path: 'unassignedJobs',
                        handler: function (e) {
                            cafm.hd.nav.showWorkOrders({
                                action: this.path
                            });
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskAssignedJobs: {
                    path: 'assignedJobs',
                        handler: function (e) {
                            cafm.hd.nav.showWorkOrders({
                                action: this.path
                            });
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskTodaysWorkOrders: {
                    path: 'todaysWorkOrders',
                        handler: function (e) {
                            cafm.hd.nav.showWorkOrders({
                                action: this.path
                            });
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                Helpdesk7DaysWorkOrders: {
                    path: 'sevenDaysWorkOrders',
                        handler: function (e) {
                            cafm.hd.nav.showWorkOrders({
                                action: this.path
                            });
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskOnHoldWorkOrders: {
                    path: 'onHoldWorkOrders',
                        handler: function (e) {
                            cafm.hd.nav.showWorkOrders({
                                action: this.path
                            });
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskOverdueWorkOrders: {
                    path: 'overdueWorkOrders',
                        handler: function (e) {
                            cafm.hd.nav.showWorkOrders({
                                action: this.path
                            });
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                StoreManagerJobs: {
                    path: 'storeManagerJobs',
                    noCache: true,
                    handler: function (e) {
                        cafm.hd.nav.showWorkOrders({
                            action: 'storeManagerJobs'
                        });
                    },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskNewSearch: {
                    path: 'newSearch/{value}',
                        noCache: true,
                            handler: function (e) {
                                cafm.hd.nav.showWorkOrders({
                                    action: 'newSearch',
                                    key: e.args.value
                                });
                            },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskNewLocalitySearch: {
                    path: 'newSearchByLocality/{localityId}',
                        noCache: true,
                            handler: function (e) {
                                cafm.hd.nav.showWorkOrders({
                                    action: 'newSearchByLocality',
                                    key: e.args.localityId
                                });
                            },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskSavedSearch: {
                    path: 'savedSearch/{value}',
                        handler: function (e) {
                            cafm.hd.nav.showWorkOrders({
                                action: 'savedSearch',
                                key: e.args.value
                            });
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskQuickSearch: {
                    path: 'search/{query}',
                        handler: function (e) {

                            var q = e.args.query;

                            if (!cafm.util.hasStringVal(q)) {

                                cafm.views.mainView().showMessage({

                                    type: cafm.enums.MessageType.Error,
                                    title: 'Search phrase not provided'
                                });

                                return;
                            }
                            // workaround - replace any starting * as that doesn't route
                            else if (q.startsWith('_*_')) {

                                q = q.replace('_*_', '*');
                            }

                            cafm.hd.nav.showWorkOrders({
                                action: 'search',
                                query: { name: 'q', value: q }
                            });
                        },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskDrillThroughSearchByStatus: {
                    path: 'drillThroughByStatus/{DrillThroughType}/{Status}',
                        noCache: true,
                            handler: function (e) { cafm.hd.nav.drillThroughSearch(e) },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskDrillThroughSearchBySla: {
                    path: 'drillThroughByPeriod/{DrillThroughType}/{WithinSla}',
                        noCache: true,
                            handler: function (e) { cafm.hd.nav.drillThroughSearch(e) },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskDrillThroughSearchByMonth: {
                    path: 'drillThroughByMonth/{DrillThroughType}/{Month}',
                        noCache: true,
                            handler: function (e) { cafm.hd.nav.drillThroughSearch(e) },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskDrillThroughSearchByPeriod: {
                    path: 'drillThroughByPeriod/{DrillThroughType}/{Period}',
                        noCache: true,
                            handler: function (e) { cafm.hd.nav.drillThroughSearch(e) },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskDrillThroughSearchByPeriodAndSla: {
                    path: 'drillThroughByPeriod/{DrillThroughType}/{Period}/{WithinSla}',
                        noCache: true,
                            handler: function (e) { cafm.hd.nav.drillThroughSearch(e) },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskDrillThroughSearchByAlertType: {
                    path: 'drillThroughByAlertType/{DrillThroughType}/{AlertType}',
                        noCache: true,
                            handler: function (e) { cafm.hd.nav.drillThroughSearch(e) },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskDrillThroughSearchByVolumeType: {
                    path: 'drillThroughByVolumeType/{DrillThroughType}/{VolumeType}',
                        noCache: true,
                            handler: function (e) { cafm.hd.nav.drillThroughSearch(e) },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                },
                HelpdeskDrillThroughSearchByOnHoldReason: {
                    path: 'drillThroughByOnHoldReason/{DrillThroughType}/{OnHoldReason}',
                    noCache: true,
                    handler: function (e) { cafm.hd.nav.drillThroughSearch(e) },
                    onPreRouteChange: function (e) { return cafm.hd.nav.onHelpdeskPreRouteChange(e); },
                    noScroll: !cafm.isMobile(),
                    documentTitle: "Helpdesk"
                }
            }
        },
        onHelpdeskPreRouteChange: function (e) {
            
            if (cafm.isMobile()) {

                cafm.handlers.exe(cafm.hd.lc.preRouteChangeHandlerName);

                var mm = $('#mobileMenu');
                if (mm.is(':visible')) {

                    mm.slideUp();
                }
                $('[data-moveto]').remove();
                $('#backBtn').hide();
            }

            cafm.filters.deregisterOnFiltersReady();
            cafm.filters.deregisterOnCriteriaChanged();

            return true;
        },
        onEditWorkOrderPreRouteChange: function (ra) {
            
            if (cafm.hd.isWorkOrderDirty() && !cafm.isOffline() && !cafm.hd.workOrderContext.isVirtual && !cafm.hd.bypassunsavedcheck) {

                cafm.util.yesNoDialogue({

                    title: cafm.res.str.TitleUnsavedChanges,
                    message: cafm.res.str.MessageUnsavedChanges,
                    messageType: cafm.enums.MessageType.Warning,
                    yesHandler: function (e) {

                        var swoa = cafm.hd.saveWoAction();
                        swoa.set('postSaveHandler', ra.routeHandle);
                        swoa.execute();
                    },
                    noHandler: function (e) {

                        cafm.hd.workOrder = null;
                        ra.routeHandle();
                    }
                });
                cafm.hd.nav.onHelpdeskPreRouteChange(ra);
                return false;
            }
            else {

                delete cafm.hd.bypassunsavedcheck;
                cafm.hd.workOrder = null;
                return cafm.hd.nav.onHelpdeskPreRouteChange(ra);
            }
        },
        showEditWorkOrder: function (args) {
            /// <summary>Shows the create work order form</summary>
            /// <param name="args" type="Object">The work order args</param>

            cafm.hd.workOrder = null;
            cafm.forms.removeMainFormToolbar();

            // TODO: Combine cafm.hd.workOrder into cafm.hd.workOrderContext
            // TODO: Combine work order form helper functions from cafm.hd into cafm.hd.workOrderContext

            var context = cafm.hd.workOrderContext = new cafm.hd.WorkOrderClientContext(args);
                        
            cafm.views.main({
                url: context.url,
                onInit: function (element) {

                    // place the context sensitive menu
                    cafm.web.funcs.placeNavMenu();
                },
                onLoad: function (element) {
                    
                    if (isMobile) 
                        $('#sub-header-toolbar .action-buttons').addClass("button-group-overflow-init");


                    let onMobileWoLoaded = function (workOrder) {
                        
                        // enable work order features and actions
                        cafm.hd.enableMobileWorkOrderFeatures(workOrder);

                                                
                        // if offline enabled add the sync icon
                        if (cafm.getClientSettings().offlineEnabled && workOrder.IsLocked) {

                            var woSync = $('<span />', {
                                'class': 'woiSync'
                            }).prependTo('#site-logo');

                            if (workOrder.IsFullObject) {

                                woSync.addClass('isFullObject');
                            }
                            else {
                                woSync.addClass('isNotLocked');
                            }
                        }

                        // show the back button
                        $('#backBtn').show();
                     
                    }
                    
                    let onWoLoaded = function (workOrder) {

                        // trim work order instruction whitespace
                        if (isStr(workOrder.Instruction)) {
                            workOrder.Instruction = workOrder.Instruction.replace(/^\s+|\s+$/g, '');
                        }

                        // populate asset meter counts
                        cafm.assets.helpers.setWorkOrderAssetMeterCounts(workOrder);

                        // populate checklist counts
                        cafm.assets.helpers.setWorkOrderAssetChecklistCounts(workOrder);

                        // force has viewed on the client (essential for offline)
                        workOrder.CurrentPersonHasViewed = true;

                        // set the current work order
                        // binds to form as Kendo observable object
                        // don't cache yet if mobile as we want to put the security onto the work order first
                        cafm.hd.setWorkOrder(workOrder, true, cafm.isMobile());

                        // the toolbar selector - differs for desktop/mobile
                        var tbSelector;

                        if (cafm.isMobile()) {

                            // mobile specific logic
                            onMobileWoLoaded(workOrder);   


                            // mobile toolbar
                            tbSelector = '.mobileToolbar';
                        }
                        else {

                            // default toolbar
                            tbSelector = '.mainToolbar';

                            // enable features - only useful for checklists at the moment
                            if (workOrder.Security) {
                                cafm.hd.enableWorkOrderFeatures(workOrder.Security)
                            }
                        }
                        
                        // set work order child counts
                        cafm.hd.setWorkOrderChildCounts(workOrder);
                                                
                        // as we are binding the view manually, we need to call prepare form to setup the controls
                        element.prepareForm(workOrder.LocalityDescription);

                        // place the toolbar that came down with the view in the central place
                        cafm.forms.placeMainFormToolbar();

                        // setup the toolbar
                        $(tbSelector).setupToolbar();

                        // set the current locality
                        cafm.hi.setCurrentLocality({
                            locality: workOrder.LocalityDescription,
                            suppressChangeEvent: true
                        });

                        // register the locality changed event for the hierarchy control
                        cafm.hi.registerOnChange(cafm.hd.handlers.localityChanged);

                        // set the first tab key in the loaded tab keys collection
                        cafm.hd.loadedTabKeys = [cafm.res.consts.DataKey_HelpdeskMainDetails];
                        
                        // set min locality level on for locality text search locality type filter
                        cafm.hd.helpers.applyMinLocalityLevel(workOrder);

                        // show the first form section
                        if (!cafm.isMobile()) {

                            cafm.forms.showFormSection(0, true);
                        }
                        else {

                            cafm.forms.showFormSection();
                        }

                        // load the save work order action
                        cafm.hd.saveWoAction().load();

                        // if not new work order
                        if (!(context.isNew || context.isVirtual)) {

                            var hisUrl;
                            if (context.isConfirmation || context.isNew) {

                                hisUrl = '{0}#{1}/{2}'.format(document.location.pathname, 'editWorkOrder', workOrder.ID) // pass nav url otherwise the confirmation view or new view is linked
                            }
                            else {

                                hisUrl = ''+document.location;
                            }
                            
                            // add the work order to the client history
                            cafm.nav.router.addRouteToHistory({
                                itemKey: workOrder.ID,
                                itemTitle: workOrder.Reference,
                                itemDetail: workOrder.Description,
                                itemType: cafm.enums.HistoryItemType.WorkOrder,
                                navUrl: hisUrl
                            });
                        }

                        // if this is a work order confirmation
                        if (context.isConfirmation) {

                            $('#printWoBtn').click(function (e) {
                                $(e.target).blur();
                                window.print();
                            });

                            $('#woConfHead').showMessage({
                                Type: cafm.enums.MessageType.Success,
                                Title: cafm.res.str.TemplateWorkOrderAssignedRef0.format(workOrder.Reference)
                            });
                        }

                        // if the work order type is portering show to locality
                        if (workOrder.WorkOrderTypeCodeID == cafm.hd.getPorteringWorkOrderTypeId()) {

                            $('#toLocality').show();
                        }

                        // create old work order values array to hold old values that are changed 
                        cafm.hd.workOrderOldValues = [];
                        // bind the set work order field handler function
                        cafm.hd.workOrder.bind('set', cafm.hd.onSetWorkOrderField);

                        // create handlers for child objects to make the work order dirty
                        cafm.handlers.set(cafm.hd.as.changedHandlerName, cafm.hd.handlers.assignmentsChanged);
                        cafm.handlers.set(cafm.hd.lc.changedHandlerName, cafm.hd.childActionPerformed);
                        cafm.handlers.set(cafm.assets.changedHandlerName, cafm.hd.handlers.assetsChanged);
                        cafm.handlers.set(cafm.costs.changedHandlerName, cafm.hd.childActionPerformed);
                        cafm.handlers.set(travel.changedHandlerName, cafm.hd.childActionPerformed);
                        cafm.handlers.set(stock.changedHandlerName, cafm.hd.childActionPerformed);
                    }

                    // if the work order is new, virtual, or there is no full cached work order and it's an edit
                    if (context.isNew || context.isVirtual || ((!context.cacheWorkOrder || context.cacheWorkOrder.isInfo) && context.workOrderId)) {
                        
                        // get the work order in context
                        cafm.hd.getWorkOrderInContext({

                            workOrderId: !context.isNew ? context.workOrderId : cafm.guid.empty,
                            callback: onWoLoaded
                        });
                    }
                    else if (context.cacheWorkOrder) { // else if there is a cached work order
                        
                        if (context.offlineEnabled && cafm.isOffline()) {

                            // if we know we're offline then go ahead and just load the wo offline
                            // this avoids the slow wait for timeout
                            onWoLoaded(context.cacheWorkOrder);
                        }
                        else {

                            // ensure work order in context
                            // makes sure the currently cached work order is up-to-date
                            cafm.hd.ensureWorkOrderInContext({

                                workOrder: context.cacheWorkOrder,
                                callback: onWoLoaded
                            });
                        }
                    }
                }
            });
        },
        showPendingSignatures: function(){

            cafm.views.main({
                url: cafm.url.get('Signature/PendingSignatures')
            });
        },
        showWorkOrders: function (args) {

            var uPre = '~/Helpdesk/',
                action = args.action,
                url = uPre + action,
                cacheUrl = url,
                key = args.key,
                query = args.query,
                query2 = args.query2,
                query3 = args.query3,
                query4 = args.query4;

            if (key) {

                url += ('/' + key);
            }

            if (query) {

                url += ('?{0}={1}'.format(query.name, encodeURIComponent(query.value)));
                
                if (query2) {

                    url += ('&{0}={1}'.format(query2.name, query2.value));

                    if (query3) {

                        url += ('&{0}={1}'.format(query3.name, query3.value));

                        if (query4) {

                            url += ('&{0}={1}'.format(query4.name, query4.value));
                        }
                    }
                }
            }

            cafm.views.main({
                url: cafm.url.get(url),
                method: args.method,
                values: args.data,
                onLoad: function (element) {

                    cafm.hd.lastSearchUrl = '~{0}{1}'.format(window.location.pathname, window.location.hash);
                    cafm.util.callFunction(args.callback, element);
                }
            });
        },
        backBtnHandle: function (e) {
            
            var n = cafm.enums.Navigatable;
            if (cafm.nav.isNav(n.HelpdeskNewWorkOrder, n.HelpdeskEditWorkOrder, n.HelpdeskConfirmWorkOrder, n.HelpdeskPendingSignatures)) {

                if (cafm.isOffline()) {

                    cafm.nav.router.navigate(cafm.enums.Navigatable.HelpdeskMyJobs);
                    return;
                }

                var ps = cafm.hd.lastSearchUrl;
                if (ps) {
                    cafm.router.loadRoute(ps);
                }
                else {
                    cafm.nav.router.navigateDefault();
                }
            }
            else {
                cafm.url.set();
            }
        },
        logWorkOrderForAsset: function (assetId) {
            /// <summary>Navigate to log a work order with an asset pre-associated</summary>
            /// <param name="assetId" type="String">The asset ID</param>

            // navigate to work order form
            // use load route as we're probably not in the helpdesk module and there will be no helpdesk router
            cafm.router.loadRoute('~/Helpdesk#' + cafm.hd.nav.routes().HelpdeskNewWorkOrderForAsset.path.replace('{assetId}', assetId));
        },
        /**
         * Open the log work order for locality view
         * @param {String} localityId The Locality ID
         */
        logWorkOrderForLocality(localityId) {

            // navigate to work order form
            // use load route as we're probably not in the helpdesk module and there will be no helpdesk router
            cafm.router.loadRoute('~/Helpdesk#' + cafm.hd.nav.routes().HelpdeskNewWorkOrderForLocality.path.replace('{localityId}', localityId));
        },
        virtualWorkOrder: function (virtualWorkOrderKey) {
            /// <summary>Navigate to a virtual work order</summary>
            /// <param name="virtualWorkOrderKey" type="String">Work order virtual key</param>

            return cafm.url.get('~/Helpdesk#' + cafm.hd.nav.routes().HelpdeskViewVirtualWorkOrder.path.replace('{virtualWorkOrderKey}', virtualWorkOrderKey));
        },
        virtualWorkOrderForAssetPath: function (assetId, virtualWorkOrderKey) {
            /// <summary>Navigate to log a work order with an asset pre-associated</summary>
            /// <param name="assetId" type="String">The asset ID</param>
            /// <param name="virtualWorkOrderKey" type="String">Work order virtual key</param>

            return cafm.url.get('~/Helpdesk#' + cafm.hd.nav.routes().HelpdeskViewVirtualWorkOrderForAsset.path.replace('{assetId}', assetId).replace('{virtualWorkOrderKey}', virtualWorkOrderKey));
        },
        drillThroughSearch: function (e) {

            var args = cafm.cache.session.get('cafm.today.drillThroughParameters');
            if (!args || args.DrillThroughType != e.args.DrillThroughType) args = e.args;

            cafm.hd.nav.showWorkOrders({
                action: 'drillthrough',
                method: 'POST',
                data: args
            });
        }
    },
    WorkOrderClientContext: function (args) {
        /// <summary>Work order client context object used determine mode specific work order client properties such as URL, document title, and getting of the cached work order (when in offline mode)</summary>
        /// <param name="args" type="Object">The work order view args</param>
                 
        let wocc = this;

        let IsNew = 0,
            IsNewForAsset = 1,
            IsNewForLocality = 2,
            IsNewForSwo = 3,
            IsCopy = 4,
            IsConfirmation = 5,
            IsEdit = 6,
            IsVirtual = 7,
            IsVirtualForAsset = 8,
            mode;

        if (!args) {

            mode = IsNew;
        }
        else if (args.swoId) {

            mode = IsNewForSwo;
        }
        else if (args.assetId && !args.virtualWorkOrderKey) {

            mode = IsNewForAsset;
        }
        else if (args.localityId) {

            mode = IsNewForLocality;
        }
        else if (args.copy) {

            mode = IsCopy;
        }
        else if (args.confirmation) {

            mode = IsConfirmation;
        }
        else if (args.assetId && args.virtualWorkOrderKey) {

            mode = IsVirtualForAsset;
        }
        else if (args.virtualWorkOrderKey) {

            mode = IsVirtual;
        }
        else {

            mode = IsEdit;
        }

        wocc.currentMode = mode;
        wocc.workOrderId = args ? args.workOrderId : null;
        wocc.isNew = mode <= IsCopy;
        wocc.isCopy = mode == IsCopy;
        wocc.isConfirmation = mode == IsConfirmation;
        wocc.isEdit = mode == IsEdit;
        wocc.isVirtual = mode == IsVirtual || mode == IsVirtualForAsset;
        wocc.offlineEnabled = cafm.getClientSettings().offlineEnabled;
        wocc.stockAllowOtherLocations = cafm.getClientSettings().helpdeskSettings.allowStockAssignmentsAtOtherLocations;
        wocc.stockIncludeOutOfStock = true;
        wocc.lastStoreroom = null;

        var getUrl = function () {

            var url;

            switch (wocc.currentMode) {

                case IsNew:

                    url = cafm.url.get('Helpdesk/NewWorkOrder');
                    break;

                case IsNewForSwo:

                    url = cafm.url.get('Helpdesk/NewWorkOrderForSwo/{0}', args.swoId);
                    break;

                case IsNewForAsset:

                    url = cafm.url.get('Helpdesk/NewWorkOrderForAsset/{0}', args.assetId);
                    break;

                case IsNewForLocality:

                    url = cafm.url.get('Helpdesk/NewWorkOrderForLocality/{0}', args.localityId);
                    break;

                case IsCopy:

                    url = cafm.url.get('Helpdesk/CopyWorkOrder/{0}', args.workOrderId);
                    break;

                case IsConfirmation:

                    url = cafm.url.get('Helpdesk/ConfirmWorkOrder/{0}', args.workOrderId);
                    break;

                case IsVirtual:

                    url = cafm.url.get('Helpdesk/ViewVirtualWorkOrder?virtualWorkOrderKey={0}', args.virtualWorkOrderKey);
                    break;

                case IsVirtualForAsset:

                    url = cafm.url.get('Helpdesk/ViewVirtualWorkOrderForAsset/{0}?virtualWorkOrderKey={1}', [args.assetId, args.virtualWorkOrderKey]);
                    break;

                default:

                    if (wocc.offlineEnabled) {

                        url = cafm.url.get('Helpdesk/EditWorkOrder');
                    }
                    else {

                        url = cafm.url.get('Helpdesk/EditWorkOrder/{0}', args.workOrderId);
                    }

                    break;
            }

            return url;
        }

        wocc.getDocumentTitle = function (workOrder) {

            switch (wocc.currentMode) {

                case IsNew:
                case IsNewForAsset:
                case IsNewForLocality:
                case IsNewForSwo:
                case IsCopy:

                    return cafm.res.str.TextNewWorkOrder;

                case IsVirtual:
                case IsVirtualForAsset:

                    return '{0} - {1}'.format(cafm.res.str.TitlePlannedWorkOrder, workOrder.Description);

                default:

                    return '[{0}] {1}'.format(parseInt(workOrder.Reference), workOrder.Description);
            }
        }

        if (mode == IsEdit && wocc.offlineEnabled && args.workOrderId) {

            wocc.cacheWorkOrder = cafm.hd.workOrderCachingHandler.getItem(args.workOrderId);
        }

        wocc.url = getUrl();
    },
    updateWorkOrderStockOptions: function (vm) {
        if (vm) {
            let woc = cafm.hd.workOrderContext;
            if (vm.AllowOtherLocations === true || vm.AllowOtherLocations === false) {
                woc.stockAllowOtherLocations = vm.AllowOtherLocations;
            }
            if (vm.IncludeOutOfStock === true || vm.IncludeOutOfStock === false) {
                woc.stockIncludeOutOfStock = vm.IncludeOutOfStock;
            }
            if ((vm.StoreroomID) && (vm.StoreroomDescription) && (vm.StoreroomLocationID)) {
                woc.lastStoreroom = {
                    ID: vm.StoreroomID,
                    Description: vm.StoreroomDescription,
                    LocationID: vm.StoreroomLocationID
                };
            }
        }
    },
    onSetWorkOrderField: function (e) {

        var oldVal = e.sender.get(e.field);
        cafm.hd.workOrderOldValues[e.field] = oldVal;
    },
    switchFormPanel: function (e) {

        if (e.item.data('key') == cafm.res.consts.DataKey_HelpdeskRiskAssessments) {

            e.item.find('.tvItem:first').click();
        }

        forms.switchFormPanel(e);
    },
    performFormAction: function (e) {

        if (!cafm.hd.workOrder) return;

        var key = e.item ? e.item.data('key') : e.key;
        var actionEnum = isStr(key) ? cafm.enums.LogWorkOrderAction[e.key] : key;
        switch (actionEnum) {
            case cafm.enums.LogWorkOrderAction.AddNote:
                e.viewModel = {
                    IsNew: true,
                    Note: {
                        NoteID: cafm.guid.newGuid(),
                        CreatedBy: cafm.auth.getLoginInfo().user.toLowerCase(),
                        CreatedDate: cafm.web.funcs.getNowUTC(),
                        LastModifiedBy: cafm.auth.getLoginInfo().user.toLowerCase(),
                        LastModifiedDate: cafm.web.funcs.getNowUTC(),
                        ParentID: cafm.hd.workOrder.ID = cafm.hd.workOrder.ID
                    },
                    ParentID: cafm.hd.workOrder.ID,
                    Stamp: cafm.hd.workOrder.Stamp
                }
                cafm.views.openChildActionWindow(e);
                break;

            case cafm.enums.LogWorkOrderAction.AssignStock:
            case cafm.enums.LogWorkOrderAction.AddCustomerRiskAssessment:
            case cafm.enums.LogWorkOrderAction.AddTradePersonRiskAssessment:

                cafm.views.openChildActionWindow(e);
                break;
        }
    },
    bindWorkOrder: function (wo, bindTarget) {
        /// <summary>Binds the work order to the container element</summary>
        /// <param name="wo" type="Object">The work order to bind</param>
        /// <param name="bindTarget" type="JQuery">The element(s) to bind the work order to</param>

        if (isUndefined(bindTarget)) bindTarget = $('#{0} .bindTarget'.format(cafm.res.consts.ElementId_MainForm));

        var viewModel = bindTarget.bindViewModel({
            viewModel: wo,
            returnObservable: true
        });

        cafm.hd.showHideWorkOrderElements(wo);
        
        // apply recent work orders if there are any
        cafm.hd.helpers.applyRecentWorkOrdersMessage(wo);

        // show messages if there are any
        cafm.msg.showFormMessages({

            clientData: wo
        });
        
        if (isMobile) {
            // create work order header details description
            if (viewModel.Description) {
                viewModel.HeaderDetailsDescription = cafm.util.reduceString(wo.Description.replace(/^\s+|\s+$/g, ''), 130, '...');                            
            }

            var vModel = {
                InternalRequiredResponseDateTime: cafm.util.ensureDate(viewModel.InternalRequiredResponseDateTime),
                InternalRequiredFixDateTime: cafm.util.ensureDate(viewModel.InternalRequiredFixDateTime),
                HeaderDetailsDescription: viewModel.HeaderDetailsDescription,
                LocalityDescription: viewModel.LocalityDescription,
                SourceDescription: viewModel.SourceDescription,
                IsTravelling: viewModel.IsTravelling,
                HasStarted: viewModel.HasStarted,
                IsComplete: viewModel.IsComplete,
                IsNotScheduled: viewModel.IsNotScheduled,
                CanStartEarly: viewModel.CanStartEarly,
                Instruction: viewModel.Instruction
            }

            var headDetails = $('#header-details');
            
            headDetails.bindViewModel(vModel);

            if (!viewModel.IsNew) headDetails.show();

            cafm.util.swipe.swipeVerticalScroll({
                target: $('#header-details .wo-instructions')
            });

            // render labour charge ticker if the current user has an in progress labour charge
            cafm.hd.lc.helpers.renderLabourChargeTicker(wo);
        }
    },
    refreshWorkOrderForm: function () {
        /// <summary>Refreshes the work order form panels, menu and toolbar</summary>

        var canEdit = cafm.getClientSettings().helpdeskSettings.canEditWoDetails;

        // check if not mobile and the work order is final, locked or not editable, if so disable the hierarchy
        if (!cafm.isMobile() && (cafm.hd.helpers.isWorkOrderFinal(cafm.hd.workOrder) || cafm.hd.workOrder.IsLocked || (!cafm.hd.workOrder.IsNew && !canEdit))) {

            cafm.hi.disableHierarchyControls();
        }
        // other wise enable hierarchy if the user can edit and it's disabled
        else if (!cafm.isMobile() && canEdit && cafm.hi.isHierarchyDisabled()) {

            cafm.hi.enableHierarchy();
        }

        // refresh the naviation menu and toolbar
        cafm.hd.refreshNavigation(function () {

            var activeElement = cafm.forms.getActiveFormSectionElement();

            cafm.hd.loadedTabKeys = [];

            if (activeElement.length) {

                cafm.hd.onEditWoTabSelect({

                    item: activeElement,
                    contentElement: $('.k-content[data-key="{0}"]'.format(activeElement.data('key'))),
                    callback: function () {
                        // set min locality level on for locality text search locality type filter
                        cafm.hd.helpers.applyMinLocalityLevel(cafm.hd.workOrder)
                    }
                });
            }
            else {

                cafm.forms.showFormSection();

                // set min locality level on for locality text search locality type filter
                cafm.hd.helpers.applyMinLocalityLevel(cafm.hd.workOrder);
            }

        });
    },
    showHideWorkOrderElements: function (wo) {
        /// <summary>Shows or hides work order form elements based on the work order</summary>
        /// <param name="wo" type="Object">The work order</param>

        if (wo.IsSchedulableType) {

            $('#woSchedulingSection').show();
        }
        else {

            $('#woSchedulingSection').hide();
        }

        if (wo.WorkOrderTypeCodeID == cafm.hd.getPorteringWorkOrderTypeId()) {

            $('#toLocality').show();
        }
        else {

            $('#toLocality').hide();
        }
    },
    setLogWoHeader: function (wo) {
        /// <summary>Sets the header text of the work order</summary>
        /// <param name="wo" type="Object">The work order</param>

        if (cafm.isMobile() && !cafm.hd.workOrderContext.isNew) {
            let sll = $('#site-logo');
            $('.lcs-indicator', sll).remove();
            HeaderContainer.setSiteHeaderText(wo.Reference);
            sll.prepend($(cafm.hd.formatLcs(wo.LifeCycleStatus, true)));
        }
        else {

            let txt;
            if (cafm.hd.workOrderContext.isNew) {

                txt = cafm.res.str.TextNewWorkOrder;
            }
            else if (cafm.hd.workOrderContext.isVirtual) {

                txt = '{0} {1}'.format(cafm.res.str.TitlePlannedWorkOrder , cafm.hd.formatLcs(wo.LifeCycleStatus));
            }
            else {

                txt = '{0} {1}'.format(wo.Reference, cafm.hd.formatLcs(wo.LifeCycleStatus));
            }

            $('#sub-header h1').html(txt);
        }

        document.title = cafm.hd.workOrderContext.getDocumentTitle(wo);
    },
    setWorkOrder: function (wo, bind, noCache) {
        /// <summary>Sets the work order and binds it to the container element</summary>
        /// <param name="wo" type="Object">The work order</param>
        /// <param name="bind" type="Boolean">flag telling the method whether or not to bind the work order</param>
        /// <param name="noCache" type="Boolean">flag telling the method not to cache the work order</param>
        
        var w = cafm.hd.workOrder;
        
        // set work order properties on the kendo observable work order
        // otherwise create observable object for work order
        if (w && w.uid) {
            w.set(wo);
        }
        else { 
            w = kendo.observable(wo);
        }
        
        // bind the work order to the form?
        if (bind) {
            
            // set the source description
            w.SourceDescription = cafm.hd.helpers.sourceDescription(w.Source);

            // set the is travelling flag
            w.IsTravelling = cafm.hd.travel.getActiveTravel(w, true) != null;

            // set the is not scheduled flag
            w.IsNotScheduled = !(w.ScheduledFromDateTime && w.ScheduledToDateTime);


            // set the is not scheduled flag
            w.IsComplete = w.LifeCycleStatus === cafm.enums.LifeCycleStatus.Complete;

            w.CanStartEarly = (w.CanStartEarly);


            cafm.hd.bindWorkOrder(w); // bind the work order
            cafm.hd.setLogWoHeader(w); // set the work order header text
        }

        // is the object cacheable?
        if (w.IsCacheable && !noCache) { 

            cafm.cache.addObject(w); // add object to cache
        }

        // set for quick access later
        cafm.hd.workOrder = w;


        // if not dirty then remove the save button indication
        if (!w.IsDirty) {

            cafm.hd.onWorkOrderMadeUndirty();
        }

        // set the object in context ID
        cafm.actions.setObjectInContextId(w.ID);
    },
    onEditWoTabSelect: function (e) {
        /// <summary>Method to handle work order tab selected event</summary>
        /// <param name="e" type="Object">Tab selected event args object</param>
        
        var item = $(e.item),
            key = item.data('key'),
            action = item.data('action');
        
        cafm.forms.selectTabKey = key;

        if (action && $.inArray(key, cafm.hd.loadedTabKeys) < 0) {
            
            var wo = cafm.hd.workOrder;

            // if main details check the user has permission to edit
            if (key == cafm.res.consts.DataKey_HelpdeskMainDetails){
                
                // if not new and not allowed to edit then change the action to read only main details
                // this is relevant to team leaders when unlocking an existing work order
                if (!wo.IsNew && 
                    (!cafm.getClientSettings().helpdeskSettings.canEditWoDetails || cafm.hd.helpers.isWorkOrderFinal(wo) || wo.IsLocked)) {

                    if (cafm.getClientSettings().offlineEnabled) {
                        action = 'Helpdesk/ReadOnlyMainDetails';
                    }
                    else {
                        action = `Helpdesk/ReadOnlyMainDetails/${wo.ID}`;
                    }
                }
            }
            
            var value = item.data('value');
            if (action && action.indexOf('{value}') > -1 ){
                
                if(isNullOrUndefined(value)) {

                    value = wo.ID;
                }

                action = action.replace('{value}', value);
            }

            var ce;
            if (isJQuery(e.contentElement) && e.contentElement.length) {

                ce = e.contentElement;
            }
            else if (e.contentElement && !isJQuery(e.contentElement)) {

                ce = $(e.contentElement);
            }            
            else {

                ce = $('> .k-content', item);
            }
            
            $(ce).loadView({
                url: cafm.url.get(action),
                isForm: false, // set to false as we want to bind and setup the form manually in the onload event of the view
                noRenderEffect: true,
                onLoad: function (taskElement) {

                    //if (isMobile && key == "HelpdeskExtendedDetails") {
                    //    // turn all dates into JS objects
                    //    cafm.util.ensureDates(wo, [                           
                    //        'InternalRequiredResponseDateTime',
                    //        'InternalRequiredFixDateTime',
                    //        'ExternalRequiredResponseDateTime',
                    //        'ExternalRequiredFixDateTime',                        
                    //        'SLAStartDateTime',
                    //        'ScheduledFromDateTime',
                    //        'ScheduledToDateTime'
                    //    ]);
                    //}

                    // bind the work order
                    cafm.hd.bindWorkOrder(wo, $('.bindTarget', taskElement));

                    // setup form elements
                    taskElement.prepareForm(wo.LocalityDescription);

                    // setup toolbar
                    $('.cTb', taskElement).setupToolbar();

                    // check for removable items
                    cafm.forms.checkForRemovables();

                    // trigger callback if necessary
                    cafm.util.callFunction(e.callback);

                    // workaround for tabstrip issue where the 2 tabs can be visible at once
                    if (!isMobile) {

                        cafm.util.callFunctionAsync({
                            func: function () {
                                var tabs = $('#{0} > .k-content'.format(cafm.res.consts.ElementId_FormWidget));
                                tabs.not('[data-key="{0}"]'.format(cafm.forms.selectTabKey)).hide();
                                var tab = tabs.filter('[data-key="{0}"]'.format(cafm.forms.selectTabKey));
                                if (!tab.is(':visible')) tab.show();
                            }
                        });
                    }                   
                }
            });

            cafm.hd.loadedTabKeys.push(item.data('key'));
        }
        else {
            var ce = $(e.contentElement);
            if (ce.css('opacity') != 1) ce.css({ opacity: 1 });
            setTimeout(function () {
                cafm.forms.checkForRemovables();
            }, 500);
            // trigger callback if necessary
            cafm.util.callFunction(e.callback);
            // TODO - There must be a better place for this (assuming it is wanted at all) !!
            if (cafm.forms.selectTabKey = cafm.res.consts.DataKey_HelpdeskStock) {
                cafm.util.callFunction('cafm.stock.onLoad');
            }
        }
    },
    hasTabLoaded: function (k) {
        /// <summary>Determines if a tab has content/loaded yet</summary>
        /// <param name="k" type="String">Tab data key</param>

        return cafm.hd.loadedTabKeys.indexOf(k) > -1;
    },
    removeTabLoadKey: function (k) {
        /// <summary>Removes a tab loaded key</summary>
        /// <param name="k" type="String">Tab data key</param>

        var ltkIndex = cafm.hd.loadedTabKeys.indexOf(k);

        if (ltkIndex > -1) {

            cafm.hd.loadedTabKeys.splice(ltkIndex, 1);
        }
    },
    setPorteringWorkOrderTypeId: function(typeId){

        cafm.hd.porteringWoTypeId = typeId;
    },
    getPorteringWorkOrderTypeId: function () {

        return cafm.hd.porteringWoTypeId;
    },
    localityRemoved: function (e) {
        /// <summary>Event handler for when locality is removed</summary>
        /// <param name="e" type="Object">Event object</param>
        
        var fieldName = 'LocalityDescription';
        cafm.hd.addSyncAction(function (syncId) {

            cafm.hd.callWoGuidSyncAction('SetForLocalityID', cafm.hd.workOrder.get('ID'), e.val, fieldName, syncId);
        }, fieldName);
        return true;
    },
    toLocalityRemoved: function(e){

        cafm.hd.workOrder.set('ToLocalityDescription', { LocalityID: cafm.guid.empty, LocalityDescription: '' });
        
        var fieldName = 'ToLocalityDescription';

        cafm.hd.addSyncAction(function (syncId) {

            cafm.hd.callWoGuidSyncAction('SetToLocalityID', cafm.hd.workOrder.get('ID'), e.val, fieldName, syncId);
        }, fieldName);

        return true;
    },
    woToLocalityChanged: function (e) {
        /// <summary>Event handler for when locality is changed</summary>
        /// <param name="e" type="Object">Event object</param>

        var fieldName = 'ToLocalityDescription';

        cafm.hd.addSyncAction(function (syncId) {

            cafm.hd.callWoGuidSyncAction('SetToLocalityID', cafm.hd.workOrder.get('ID'), cafm.hd.workOrder.ToLocalityDescription.LocalityID, fieldName, syncId);
        }, fieldName, 500);
    },
    woFormLookupChanged: function (e) {
        /// <summary>Event handler for when a log work lookup field is changed</summary>
        /// <param name="e" type="Object">Lookup changed event object</param>

        var fieldName = e.target.getBoundFieldName();
        var actionName = 'Set' + fieldName;

        cafm.hd.addSyncAction(function (syncId) {

            cafm.hd.callWoGuidSyncAction(actionName, cafm.hd.workOrder.get('ID'), e.val, fieldName, syncId);

            if (fieldName === 'WorkOrderTypeCodeID') cafm.hd.loadedTabKeys = [cafm.res.consts.DataKey_HelpdeskMainDetails];
        }, fieldName);
    },
    woFormWoTypeLookupChanged: function (e) {
        /// <summary>Event handler for when a log work lookup field is changed</summary>
        /// <param name="e" type="Object">Lookup changed event object</param>

        cafm.hd.woFormLookupChanged(e);

        if (e.val == cafm.hd.getPorteringWorkOrderTypeId()) {

            $('#toLocality').slideDown();
        }
        else {

            $('#toLocality').slideUp();
        }
    },
    woAutoCompleteTextChanged: function (e) {
        /// <summary>Event handler for when a log work auto complete field is changed</summary>
        /// <param name="e" type="Object">Auto complete changed event object</param>

        var txtEl = e.target;
        var fieldName = txtEl.getBoundFieldName();
        if (fieldName) {

            cafm.hd.addSyncAction(function (syncId) {

                var dotIndex = fieldName.indexOf('.');
                if (dotIndex > -1) fieldName = fieldName.substring(dotIndex + 1);
                var actionName = 'Set' + fieldName;
                cafm.hd.callWoTextSyncAction(actionName, cafm.hd.workOrder.get('ID'), e.val, fieldName, syncId);
            }, fieldName);
        }
    },
    woFormTextChanged: function (e) {
        /// <summary>Event handler for when a log work text field is changed</summary>
        /// <param name="e" type="Object">The DOM event object</param>

        var txtEl = $(e.target);
        var fieldName = txtEl.getDataBoundProps()['value'];
        if (fieldName) {

            cafm.hd.addSyncAction(function (syncId) {

                var dotIndex = fieldName.indexOf('.');
                if (dotIndex > -1) fieldName = fieldName.substring(dotIndex + 1);
                var actionName = 'Set' + fieldName;
                var v;
                var kc;
                if ((kc = txtEl.data('kendoDateTimePicker'))) {
                    v = kc.value();
                }
                else if ((kc = txtEl.data('kendoDatePicker'))) {
                    v = kc.value();
                }
                else {
                    v = txtEl.val();
                }

                if (!txtEl.attr("required") || (v && txtEl.attr("required"))) {

                    cafm.hd.callWoTextSyncAction(actionName, cafm.hd.workOrder.get('ID'), v, fieldName, syncId);
                }
            }, fieldName);
        }
    },
    woDropdownChanged: function (e) {
        /// <summary>Event handler for when a log work dropdown field is changed</summary>
        /// <param name="e" type="Object">Dropdown changed event object</param>

        var el = $(e.target);
        var fieldName = el.getBoundFieldName();
        if (fieldName) {

            cafm.hd.addSyncAction(function (syncId) {

                var dotIndex = fieldName.indexOf('.');
                if (dotIndex > -1) fieldName = fieldName.substring(dotIndex + 1);
                var actionName = 'Set' + fieldName;
                var drp = el.data('kendoDropDownList');
                cafm.hd.callWoTextSyncAction(actionName, cafm.hd.workOrder.get('ID'), drp.value(), fieldName, syncId);
            }, fieldName);
        }
    },
    woCheckboxChanged: function (e) {
        /// <summary>Event handler for when a log work checkbox field is changed</summary>
        /// <param name="e" type="Object">Event object</param>

        var el = $(e.target);
        var fieldName = el.getDataBoundProps()['checked'];
        if (fieldName) {

            cafm.hd.addSyncAction(function (syncId) {

                var dotIndex = fieldName.indexOf('.');
                if (dotIndex > -1) fieldName = fieldName.substring(dotIndex + 1);
                var actionName = 'Set' + fieldName;
                cafm.hd.callWoTextSyncAction(actionName, cafm.hd.workOrder.get('ID'), el.isChecked(), fieldName, syncId);
            }, fieldName);
        }
    },
    swoChanged: function (e) {

        var fieldName = $(e.target).getBoundFieldName(),
            val = e.val;

        if (!val && e.currentTarget && e.currentTarget.tagName.toLowerCase() == 'select') {

            var kddl = $(e.currentTarget).getKendoDropDownList();
            if (kddl) val = kddl.value();
        }

        cafm.hd.addSyncAction(function (syncId) {  
            var actionName = 'Set' + fieldName;
            cafm.hd.callWoGuidSyncAction(actionName, cafm.hd.workOrder.get('ID'), val, fieldName, syncId, true);
            cafm.hd.loadedTabKeys = [cafm.res.consts.DataKey_HelpdeskMainDetails];         
        }, fieldName);
       
    },
    addSyncAction: function (handler, fieldName, timeout) {

        if (!cafm.hd.workOrder) {

            return;
        }

        if (!cafm.hd.syncActions) {

            cafm.hd.syncActions = [];
        }
        else {

            var syncOp = cafm.util.find(cafm.hd.syncActions, function (so) {

                return so.fieldName == fieldName;
            });

            if (syncOp) {

                cafm.hd.removeSyncAction(syncOp.syncId);
            }
        }

        var syncId = cafm.guid.newGuid();

        cafm.hd.syncInProgress = true;
        cafm.hd.syncActions.push({

            syncId: syncId,
            fieldName: fieldName,
            timeout: setTimeout(function (e) {
                handler(syncId);
            }, timeout ? timeout : 250)
        });
    },
    clearSyncActions: function () {

        if (cafm.hd.syncActions) {

            for (var key in cafm.hd.syncActions) {

                clearTimeout(cafm.hd.syncActions[key].timeout);
                delete cafm.hd.syncActions[key];
            }
        }
    },
    removeSyncAction: function (syncId) {

        cafm.util.removeWhere(cafm.hd.syncActions, function (so) {

            var match = so.syncId == syncId;

            if (match) {

                clearTimeout(so.timeout);
            }

            return match;
        });

        if (!cafm.util.hasItem(cafm.hd.syncActions)) {

            cafm.hd.syncInProgress = false;
        }
    },
    callWoTextSyncAction: function (woAction, woid, txt, field, syncId) {
        /// <summary>Event handler for when a work order property is changed</summary>
        /// <param name="woAction" type="Object">Helpdesk API action name</param>
        /// <param name="woid" type="String">Work order id</param>
        /// <param name="lid" type="String">Lookup id guid as string</param>

        cafm.hd.callSyncAction({
            url: cafm.url.api('WorkOrder/{0}'.format(woAction)),
            values: {
                EntityID: woid,
                Value: txt
            },
            field: field,
            syncId: syncId
        });
    },
    callWoGuidSyncAction: function (woAction, woid, lid, field, syncId, refreshNavigation) {
        /// <summary>Event handler for when a work order property is changed</summary>
        /// <param name="woAction" type="Object">Helpdesk API action name</param>
        /// <param name="woid" type="String">Work order id</param>
        /// <param name="lid" type="String">Lookup id guid as string</param>

        cafm.hd.callSyncAction({
            url: cafm.url.api('WorkOrder/{0}'.format(woAction.replace(/\./g, ''))),
            values: cafm.util.createParentChildId(woid, lid),
            field: field,
            syncId: syncId,
            refreshNavigation: refreshNavigation
        });
    },
    callSyncAction: function (options) {
        /// <summary>Call the sync work order action</summary>
        /// <param name="options" type="Object">The sync action options</param>

        if (isNullOrUndefined(options.preventDirty) || options.preventDirty === false) {

            cafm.hd.triggerWorkOrderDirty();
        }

        var field = options.field,
            actionOptions = {
            id: 'woSyncAction',
            url: options.url,
            requestDelay: 0,
            values: options.values,
            elementId: options.elementId ? options.elementId : cafm.res.consts.ElementId_MainForm,
            loaderSelector: options.loaderSelector,
            loaderTarget: options.refreshNavigation ? $('#main') : null,
            preventValidate: isUndefined(options.preventValidate) ? true : options.preventValidate,
            offlineActionType: options.offlineActionType,
            statusCodeFuncs: {
                200: function (workOrder, s, m, a) {

                    // if we have a work order from the response
                    if (workOrder) {

                        // if the locality has changed
                        if (!cafm.hd.isWorkOrderLocalityEqual(cafm.hd.workOrder, workOrder)) {

                            cafm.hd.helpers.changeAdditionalDescription(cafm.hd.workOrder.CurrencySymbol, workOrder.CurrencySymbol);

                            //cafm.hd.workOrder.CurrencySymbol = workOrder.CurrencySymbol;
                            //cafm.hd.workOrder.CurrencyCode = workOrder.CurrencyCode
                            // refresh the forms data locality
                            cafm.forms.ensureDataLocalityId(workOrder.LocalityDescription);
                        }

                        cafm.hd.setWorkOrder(workOrder, true);

                        // apply recent work orders if there are any
                        cafm.hd.helpers.applyRecentWorkOrdersMessage(workOrder);

                        // show messages if there are any
                        cafm.msg.showFormMessages({

                            clientData: workOrder,
                            noTransition: true // set to true as this could be a nuisance for every text change on main details
                        });                   

                        // sync client server objects
                        if (!isFunc(options.syncWorkOrder)) {
                            cafm.util.syncClientServerObjects(cafm.hd.workOrder, workOrder, cafm.util.where(cafm.util.selectValue(cafm.hd.syncActions, 'fieldName'), function (f) { return f != options.field }));
                        }
                        else {
                            options.syncWorkOrder(workOrder);
                        }

                        // show hide work order elements
                        cafm.hd.showHideWorkOrderElements(workOrder);
                        
                        switch (options.field) {

                            case 'ServiceProvider.ID':
                                if (!workOrder.ServiceProvider) {
                                    cafm.hd.workOrder.ServiceProvider = {};
                                }
                                // if service provider has changed then call the assignments changed handler
                                cafm.hd.handlers.assignmentsChanged(workOrder);
                                break;
                            case 'ApplyQuotationMarginOnEstimatedCosts':
                            case 'QuotationCostIsAbsolute':
                            case 'QuotationMarginMisc':
                                costs.refreshList();
                                break;
                        }
                    }

                    // check refresh nav option
                    if (options.refreshNavigation) {

                        // now do the refresh
                        cafm.hd.refreshNavigation(cafm.isMobile() && field === 'LocalityDescription' ? cafm.hd.onWorkOrderMadeDirty : null);
                    }

                    cafm.costs.refreshList();

                    // call optional and additional success handler
                    cafm.util.callFunction(options.success, workOrder, s, m, a);
                }
            },
            error: function() {
                
                // if there was a server error then restore the old value
                if (field) {

                    cafm.hd.workOrder.set(field, cafm.hd.workOrderOldValues[field]);
                }

                // call optional error handler
                cafm.util.callFunction(options.error);
            },
            complete: function () {

                // finally remove the sync action
                cafm.hd.removeSyncAction(options.syncId);
            },
            fallback: options.fallback
        };
        cafm.actions.execute(actionOptions);
    },
    /// <field name='saveWoAction' type='cafm.actions.Action'>Action for saving the work order</field>
    saveWoAction: function () {

        var swoa = cafm.actions.get('SaveWorkOrder');

        if (!swoa) {

            swoa = new cafm.actions.Action({

                id: 'SaveWorkOrder',
                url: cafm.url.api('WorkOrder/Save'),
                elementId: cafm.res.consts.ElementId_MainForm,
                loaderSelector: '#mainContentPane,#sub-header-toolbar [data-key="Save"]',
                loaderText: cafm.res.str.MessageSavingWorkOrder,
                validationMessage: cafm.res.str.MessageWorkOrderInvalid,
                validate: function(){

                    var jobDetails = $('#jobDetailsPlc');
                    if (jobDetails.length && cafm.getClientSettings().helpdeskSettings.isSwoRequired && !cafm.util.guidHasValue(cafm.hd.workOrder.StandardWorkOrderID)) {

                        this.set('valid', false);
                        setTimeout(function () { jobDetails.validateElement(); }, 250);
                    }
                },
                onInvalid: function () {

                    var woTabs = $('#' + cafm.res.consts.ElementId_FormWidget);
                    var invalid = $('.k-invalid', woTabs);

                    if (invalid.length) {

                        var contentTab = invalid.parents('.k-content:first');
                        var contentTabs = contentTab.parent().children('.k-content');
                        var index = contentTabs.index(contentTab);
                        cafm.forms.showFormSection(index);
                        woTabs.ensureInvalidFieldsAreVisible();
                        
                        if (cafm.isMobile()) {

                            window.scrollTo(0, 0);
                        }
                        else {

                            $('#centreCol').scrollTop(0);
                        }
                    }
                },
                preExecuteConstraint: function () {

                    $('#minForLocalityMsg').remove();
                    cafm.hd.saveWoExeConstraintCount = 0;
                },
                executeConstraint: function () {

                    var exeValid = !cafm.hd.syncActions || !cafm.hd.syncActions.length;

                    cafm.hd.saveWoExeConstraintCount++;

                    return exeValid || cafm.hd.saveWoExeConstraintCount == 20;
                },
                beforeSend: function() {

                    cafm.router.enablePreRouteChangedHandler(false);
                },
                error: function() {

                    cafm.router.enablePreRouteChangedHandler(true);
                },
                statusCodeFuncs: {
                    200: function (w, s, m, a) {

                        $('#editWorkOrderTbPlc').slideUp();

                        // is the object cacheable?
                        if (w.IsCacheable) {

                            cafm.cache.addObject(w); // add object to cache
                        }

                        cafm.hd.clearSyncActions();

                        if (cafm.hd.workOrderContext.isNew) {
                            
                            cafm.nav.router.navigate(cafm.enums.Navigatable.HelpdeskConfirmWorkOrder, {
                                workOrderId: w.ID
                            });
                        }
                        else {

                            cafm.hd.onEndWorkOrderEdit(a.get('postSaveHandler'));
                        }

                        delete cafm.hd.workOrderContext;
                    },
                    500: function (r, s, m) {

                        var errorKey = r.getResponseHeader(cafm.res.consts.ResHeader_ErrorKey);
                        if ((errorKey == cafm.res.consts.ErrorKey_MinForLocality || errorKey == cafm.res.consts.ErrorKey_MinToLocality) && !cafm.browsers.isIe9Or10()) {

                            var msgHtml = [];
                            msgHtml.push('<span id="minForLocalityMsg" class="k-widget k-tooltip k-tooltip-validation k-invalid-msg">');
                            msgHtml.push('<span class="k-icon k-i-warning"></span>');
                            msgHtml.push(unescape(r.getResponseHeader(cafm.res.consts.ResHeader_ErrorMessage)));
                            msgHtml.push('</span>');

                            var appendId = errorKey == cafm.res.consts.ErrorKey_MinForLocality ? 'forLocality' : 'toLocality';
                            $(msgHtml.join('')).appendTo($('#{0} .forLocality'.format(appendId)));
                        }

                        if (cafm.isMobile()) {

                            window.scrollTo(0, 0);
                        }
                        else {

                            $('#centreCol').scrollTop(0);
                        }
                    }
                }
            });
        }

        return swoa;
    },
    lcsDescription: function (n) {
        /// <summary>Gets a localised life cycle status description</summary>
        /// <param name="n" type="Integer">The life cycle status enum value</param>
        /// <returns type="String">The life cycle status description</param>

        return cafm.util.toSafeTemplateLabel(cafm.enums.LcsLabels[n]);
    },
    onWoInfoDataRetrieved: function (d, element) {
        /// <summary>Function to manipulate work order info data rows</summary>
        /// <param name="d" type="Array">The array of work order info data</param>
        /// <param name="element" type="Object">The work order grid or list element (optional and only required for single item auto linking)</param>
        
        // check for element and ensure that the user has elected to search and the control is not initialising
        if (element && (cafm.web.funcs.isTopSearch() || element.data('Searching')) && d.length == 1) {

            if (cafm.isMobile() || !cafm.filters.getViewModel().VisibleColumnsChanged) {

                // navigate to work order form, search result returned only one item
                cafm.nav.router.navigate(cafm.enums.Navigatable.HelpdeskEditWorkOrder, {
                    workOrderId: d[0].ID
                });
            }
        }

        // loop each work order and ensure the life cycle status enum and description is set as the client requires
        d.forEach(function (wo) {

            if (!isNum(wo.LifeCycleStatusEnum)) {

                wo.LifeCycleStatusEnum = wo.LifeCycleStatus;
                wo.LifeCycleStatus = cafm.hd.lcsDescription(wo.LifeCycleStatus);
            }
        });
    },
    onWoInfoDataBound: function (e) {
        /// <summary>Executes after the work order grid has been bound</summary>
        /// <param name="e" type="Object">List databound args</param>

        e.sender.element.off('click').on('click', '.woInfoRef', function (ev) {

            var uid = $(ev.target).parents('[data-uid]:first').data('uid');

            if (uid) {

                var item = e.sender.dataSource.getByUid(uid);

                // set this single use flag, to stop the unsaved changes prompt - only when the grid is flagged to do so
                if (e.sender.element.data('bypassunsavedcheck')) cafm.hd.bypassunsavedcheck = true;

                if (item.VirtualKey) {

                    cafm.url.set(cafm.hd.nav.virtualWorkOrder(item.VirtualKey));
                }
                else {

                    cafm.nav.router.navigate(cafm.enums.Navigatable.HelpdeskEditWorkOrder, { workOrderId: item.ID });
                }
            }
            return false;
        });
    },
    onMobileWoInfoDataBound: function (e) {
        /// <summary>Executes after the work order list has been bound</summary>
        /// <param name="e" type="Object">List databound args</param>

        var dse = e.sender.element;

        dse.off('click touchstart').on('click touchstart', '.cLvIt', function (ev) {

            dse.find('.k-state-focused').removeClass('k-state-focused');
            $(ev.currentTarget).addClass('k-state-focused');
        });
        
        dse.find('.woInfoRef,.list-chevron').click(function (ev) {

            var li = $(ev.currentTarget);
            if (!li.hasClass('cLvIt')) {
                li = li.parents('.cLvIt:first');
            }

            var id = li.data('id');
            if (id) {

                cafm.nav.router.navigate(cafm.enums.Navigatable.HelpdeskEditWorkOrder, {
                    workOrderId: id
                });
            }
        });

        var cs = cafm.getClientSettings();
        
        // if offline enabled add the sync icon
        if (cs.offlineEnabled && cafm.nav.isNav(cafm.enums.Navigatable.HelpdeskMyJobs)) {

            if (!cafm.isOffline()) {

                // set last my jobs sync here
                cafm.cache.set(cafm.res.consts.CacheKey_LastMyJobsSync, cafm.web.funcs.getSessionDateTimeNowText());
            }

            // add the sync icon
            dse.find('.cLvIt').each(function (i, e) {
            
                var li = $(e);
                var wo = cafm.hd.workOrderCachingHandler.getItem(li.data('id'));
                var woSync = $('<span />', {
                    'class': 'woiSync'
                }).prependTo(li);

                if(wo && wo.IsLocked && wo.IsFullObject) {

                    woSync.addClass('isFullObject');
                }
                else if(!wo || !wo.IsLocked) {
                    woSync.addClass('isNotLocked');
                }
            });
        }

        if (cs.offlineEnabled && cafm.isOffline()) {

            $('#filterTabs > .k-item:not([data-key=MainFilters])').hide();
            $('#filterTabs > .k-item[data-key=MainFilters] .cFilter').hide();
            $('#SourceFilter').closest('.cFilter').show();
        }
        else {

            $('#filterTabs > .k-item:not([data-key=MainFilters])').show();
            $('#filterTabs > .k-item[data-key=MainFilters] .cFilter:hidden').show();
        }
    },
    onWoInfoSelected: function (args, selected) {
        /// <summary>Handler for the work order grid selection changed event</summary>
        /// <param name="args" type="Object">List selection changed args</param>
        /// <param name="selected" type="Array">List selected items array</param>

        // check for any invalid work orders
        var invalidCount = cafm.util.count(selected, function (wo) {

            return wo.IsLocked || wo.LifeCycleStatusEnum == cafm.enums.LifeCycleStatus.Discarded;
        });
        
        // if there's one then we can show copy
        if (selected.length == 1) {

            // show copy and preview actions
            if (invalidCount < 1) {
                cafm.hd.helpers.showHideActionButton(true, cafm.enums.WorkOrderAction.Copy);
            }

            cafm.hd.helpers.showHideActionButton(true, cafm.enums.WorkOrderAction.Preview);

            if (cafm.layout.isRightColumnVisible()) {

                cafm.hd.showWorkOrderPreview(selected[0]);
            }
        }
        else {

            // hide copy and preview as can only do one at a time
            cafm.hd.helpers.showHideActionButton(false, cafm.enums.WorkOrderAction.Copy);
            cafm.hd.helpers.showHideActionButton(false, cafm.enums.WorkOrderAction.Preview);
        }

        // don't show any actions if the selection is invalid
        if (invalidCount > 0) {

            // hide all 4 actions as there is an invalid work order
            cafm.hd.helpers.showHideActionButton(false, cafm.enums.WorkOrderAction.Complete, cafm.enums.WorkOrderAction.Copy, cafm.enums.WorkOrderAction.Issue, cafm.enums.WorkOrderAction.Resolve);
            return;
        }

        // if there are selected items
        if (selected.length > 0) {

            // always show print when work orders are selected
            cafm.hd.helpers.showHideActionButton(true, cafm.enums.WorkOrderAction.Print);

            // check for completed items
            var compCount = cafm.util.count(selected, function (wo) {

                return wo.LifeCycleStatusEnum == cafm.enums.LifeCycleStatus.Completed;
            });

            // check for resolved items
            var resCount = cafm.util.count(selected, function (wo) {

                return wo.LifeCycleStatusEnum == cafm.enums.LifeCycleStatus.Resolved;
            });

            // if there's no completed items we can attempt to show actions
            if (compCount == 0) {

                // show complete 
                cafm.hd.helpers.showHideActionButton(true, cafm.enums.WorkOrderAction.Complete);

                // show issue
                cafm.hd.helpers.showHideActionButton(true, cafm.enums.WorkOrderAction.Issue);

                // if none resolved then show resolve
                if (resCount == 0) {

                    cafm.hd.helpers.showHideActionButton(true, cafm.enums.WorkOrderAction.Resolve);
                }
                else {

                    // otherwise hide resolve
                    cafm.hd.helpers.showHideActionButton(false, cafm.enums.WorkOrderAction.Resolve);
                }
            }
            else {

                // hide all 3 actions as can't complete/issue/resolve a completed work order
                cafm.hd.helpers.showHideActionButton(false, cafm.enums.WorkOrderAction.Complete, cafm.enums.WorkOrderAction.Issue, cafm.enums.WorkOrderAction.Resolve);
            }
        }
        else {

            // hide all 4 actions, none selected
            cafm.hd.helpers.showHideActionButton(false, cafm.enums.WorkOrderAction.Copy, cafm.enums.WorkOrderAction.Complete, cafm.enums.WorkOrderAction.Issue, cafm.enums.WorkOrderAction.Resolve, cafm.enums.WorkOrderAction.Print);
        }
        
    },
    formatLcs: function (lcsEnum, justIcon) {
        /// <summary>Function to show a formatted life cycle status</summary>
        /// <param name="lcsEnum" type="Integer">The life cycle status enum integer</param>
        /// <param name="justIcon" type="Boolean">Flag to just render the icon</param>
        /// <returns type="String">Returns HTML string</param>

        var d = cafm.hd.lcsDescription(lcsEnum),
            t = '<span class="lcs-indicator lcs{0}" title="{1}"></span>'.format(lcsEnum, d);

        if(!cafm.util.isTrue(justIcon)){
            
            t += '<span class="lcs">{0}</span>'.format(d);
        }

        return t;
    },
    formatCurrency: function (currencySymbol, value) {

        var formatValue = kendo.toFormatNumber(value, 'c', currencySymbol);
        var t = '<span class="lcs">{0}</span>'.format(formatValue);

        return t;
    },
    setLcsColours: function (lcsMap) {

        var sheet = document.createElement('style');
        var classes = [];

        for (var key in lcsMap) {

            classes.push('.lcs{0} { background:{1}; } '.format(key, lcsMap[key]));
        }

        sheet.innerHTML = classes.join('');
        $('head').append(sheet);
    },
    renderTrafficLight: function (alertStatus, lcsStatus) {

        if (alertStatus == cafm.enums.AlertStatus.Green || lcsStatus == cafm.enums.LifeCycleStatus.Discarded || lcsStatus == cafm.enums.LifeCycleStatus.Completed || lcsStatus == cafm.enums.LifeCycleStatus.Resolved) {
            return '';
        }
        return '<span class="alertStatus" data-value="{0}"></span>'.format(alertStatus);
    },
    renderOnHoldReview: function (onHoldReview) {

        if (!onHoldReview) {
            return '';
        }
        else {
            return '<span class="alertStatus"></span>';
        }
    },
    transformToLightWorkOrders: function (workOrders) {
        /// <summary>Transforms an array of work orders to an array of light work orders</summary>
        /// <param name="workOrders" type="Array">Work order array</param>
        /// <returns type="Array">The array of transformed work orders</returns>

        return cafm.util.transformArray(workOrders, function (w) {
            return cafm.hd.transformToLightWorkOrder(w);
        });
    },
    transformToLightWorkOrder: function (workOrder) {
        /// <summary>Transforms a work order to a light work order</summary>
        /// <param name="workOrder" type="Object">The work order object</param>
        /// <returns type="Object">The transformed work order</returns>

        return {
            WorkOrderID: workOrder.WorkOrderID || workOrder.ID,
            Reference: workOrder.Reference,
            LifeCycleStatus: workOrder.LifeCycleStatus,
            Stamp: workOrder.Stamp
        };
    },
    onEndWorkOrderEdit: function (handler) {
        /// <summary>Determines what to display after editing a work order has been completed</summary>

        cafm.hd.clearSyncActions();

        if (isFunc(handler)) {

            handler();
            return;
        }

        cafm.hd.workOrder = null;

        var prevSearch = cafm.hd.lastSearchUrl;

        if (prevSearch) {
            
            cafm.router.loadRoute(prevSearch);
        }
        else {

            cafm.nav.router.navigateDefault();
        }
    },
    onPreBindFilters: function (criteria, filterPanel) {
        
        var asl = [];
        if (cafm.util.hasEnumValue(criteria.AlertStatus, cafm.enums.AlertStatus.Amber)) {

            asl.push({
                value: cafm.enums.AlertStatus.Amber
            });
        }
        if (cafm.util.hasEnumValue(criteria.AlertStatus, cafm.enums.AlertStatus.Blue)) {

            asl.push({
                value: cafm.enums.AlertStatus.Blue
            });
        }
        if (cafm.util.hasEnumValue(criteria.AlertStatus, cafm.enums.AlertStatus.Green)) {

            asl.push({
                value: cafm.enums.AlertStatus.Green
            });
        }
        if (cafm.util.hasEnumValue(criteria.AlertStatus, cafm.enums.AlertStatus.Red)) {

            asl.push({
                value: cafm.enums.AlertStatus.Red
            });
        }
        
        var lcsl = [];
        if (cafm.util.hasEnumValue(criteria.LifeCycleStatus, cafm.enums.LifeCycleStatus.Completed)) {

            lcsl.push({
                value: cafm.enums.LifeCycleStatus.Completed
            });
        }
        if (cafm.util.hasEnumValue(criteria.LifeCycleStatus, cafm.enums.LifeCycleStatus.Discarded)) {

            lcsl.push({
                value: cafm.enums.LifeCycleStatus.Discarded
            });
        }
        if (cafm.util.hasEnumValue(criteria.LifeCycleStatus, cafm.enums.LifeCycleStatus.NotificationDue)) {

            lcsl.push({
                value: cafm.enums.LifeCycleStatus.NotificationDue
            });
        }
        if (cafm.util.hasEnumValue(criteria.LifeCycleStatus, cafm.enums.LifeCycleStatus.OnHold)) {

            lcsl.push({
                value: cafm.enums.LifeCycleStatus.OnHold
            });
        }
        if (cafm.util.hasEnumValue(criteria.LifeCycleStatus, cafm.enums.LifeCycleStatus.Open)) {

            lcsl.push({
                value: cafm.enums.LifeCycleStatus.Open
            });
        }
        if (cafm.util.hasEnumValue(criteria.LifeCycleStatus, cafm.enums.LifeCycleStatus.Resolved)) {

            lcsl.push({
                value: cafm.enums.LifeCycleStatus.Resolved
            });
        }
        if (cafm.util.hasEnumValue(criteria.LifeCycleStatus, cafm.enums.LifeCycleStatus.Pending)) {

            lcsl.push({
                value: cafm.enums.LifeCycleStatus.Pending
            });
        }

        var source;      

        if (criteria.Source == cafm.enums.WorkOrderSource.Reactive) {

            source = cafm.enums.WorkOrderSource.Reactive;
        }
        else if (criteria.Source == cafm.enums.WorkOrderSource.Planned) {

            source = cafm.enums.WorkOrderSource.Planned;
        }
        else {

            source = cafm.enums.WorkOrderSource.All;
        }

        if (criteria.uid) {

            criteria.SuppressChangedEvent = true;
            criteria.set('AlertStatusList', asl);
            criteria.set('LifeCycleStatusList', lcsl);
            criteria.set('Source', source);
            criteria.SuppressChangedEvent = false;
        }
        else {

            criteria.AlertStatusList = asl;
            criteria.LifeCycleStatusList = lcsl;
            criteria.Source = source;
        }
    },
    onPreSearch: function (filterPanel) {

        var criteria = filterPanel.getViewModel();

        var lcsList = criteria.get('LifeCycleStatusList');
        if (lcsList && lcsList.length) {

            var lcStatus = 0;
            $.each(lcsList, function (i, lcs) {

                lcStatus += parseInt(cafm.util.getItemValue(lcs));
            });

            criteria.set('LifeCycleStatus', lcStatus);
        }
        else {

            criteria.set('LifeCycleStatus', cafm.filters.contextDefaultCriteria.LifeCycleStatus);
            criteria.set('LifeCycleStatusList', cafm.filters.contextDefaultCriteria.LifeCycleStatusList);
        }

        var alertList = criteria.get('AlertStatusList');
        if (alertList && alertList.length) {

            var alertStatus = 0;
            $.each(alertList, function (i, als) {

                alertStatus += parseInt(cafm.util.getItemValue(als));
            });
            criteria.set('AlertStatus', alertStatus);
        }
        else {

            criteria.set('AlertStatus', cafm.filters.contextDefaultCriteria.AlertStatus);
            criteria.set('AlertStatusList', cafm.filters.contextDefaultCriteria.AlertStatusList);
        }

        if (!criteria.get('Source')) {

            criteria.set('Source', cafm.filters.contextDefaultCriteria.Source);
        }

        if (!criteria.get('PersonAssociationType')) {

            criteria.set('PersonAssociationType', cafm.filters.contextDefaultCriteria.PersonAssociationType);
        }

        cafm.util.setMultipleParameterValues(criteria, 'WorkOrderTypeCodePairs', 'WorkOrderTypeCodeIDs');
        cafm.util.setMultipleParameterValues(criteria, 'WorkOrderGroupCodePairs', 'WorkOrderGroupCodeIDs');
        cafm.util.setMultipleParameterValues(criteria, 'ServiceProviderPairs', 'ServiceProviderIDs');
        cafm.util.setMultipleParameterValues(criteria, 'TradeCodePairs', 'TradeCodeIDs');
        cafm.util.setMultipleParameterValues(criteria, 'PracticeCodePairs', 'PracticeCodeIDs');
        cafm.util.setMultipleParameterValues(criteria, 'ForLocalityPairs', 'ForLocalityIDs');
        cafm.util.setMultipleParameterValues(criteria, 'ReasonCodeID', 'ReasonCodeIDs');
        cafm.util.setMultipleParameterValues(criteria, 'ServiceProviderTypePairs', 'ServiceProviderTypeIDs');
        cafm.util.setMultipleParameterValues(criteria, 'AssetGroupCodePairs', 'AssetGroupIDs');


               
        // ensure only a valid trade filter type is set
        if (!cafm.util.hasItem(criteria.TradeCodeIDs) && !cafm.nav.isNav(cafm.enums.Navigatable.HelpdeskAssignedJobs, cafm.enums.Navigatable.HelpdeskUnassignedJobs)) {
            
            var tf = criteria.TradeFilter;

            if (isStr(tf)) {

                tf = parseInt(tf);
            }

            if (!cafm.util.arrayContains([cafm.enums.FilterTrade.All, cafm.enums.FilterTrade.Assigned, cafm.enums.FilterTrade.Unassigned], tf)) {

                criteria.set('TradeFilter', cafm.enums.FilterTrade.All);
            }
        }

        filterPanel.mergeViewModel(criteria);

        return criteria;
    },
    childActionPerformed: function (workOrder, closeWin) {

        if (!isNullOrUndefined(workOrder)) {
                        
            if (!cafm.hd.isWorkOrderLocalityEqual(cafm.hd.workOrder, workOrder)) {

                if (cafm.isMobile()) {
                    
                    cafm.forms.ensureDataLocalityId(workOrder.LocalityDescription);
                }
                else {

                    cafm.hi.setCurrentLocality({
                        locality: workOrder.LocalityDescription,
                        suppressChangeEvent: true
                    });
                    cafm.forms.ensureDataLocalityId(workOrder);
                }

                // update the cached selectedText used by the auto complete control - this is necessary as the auto complete control uses the DOM to manage its state and not the work order view model.
                $('#LocalityDescription_LocalityID').data('selectedText', workOrder.LocalityDescription.LocalityTrail);
            }
            
            cafm.hd.setWorkOrder(workOrder, true);
        }

        if (isUndefined(closeWin) || closeWin === true) cafm.views.closeActionWindow();

        if ((!workOrder && (!cafm.isMobile() || cafm.hd.workOrder.IsNew)) || (workOrder && workOrder.IsDirty)) {

            cafm.hd.triggerWorkOrderDirty();
        }
    },
    childUpdated: function (workOrder) {

        if (isObj(workOrder)) {

            cafm.hd.setWorkOrder(workOrder, true);
        }

        cafm.views.closeActionWindow();

        if ((!workOrder && (!cafm.isMobile() || cafm.hd.workOrder.IsNew)) || (workOrder && workOrder.IsDirty)) {

            cafm.hd.triggerWorkOrderDirty();
        }
    },
    refreshNavigation: function (callback, suppressSigRefresh) {
        /// <summary>Refreshes the navigation menu to reflect the current view and work order state</summary>

        // if no work order is still in context assume the user navigated away...
        if (!cafm.hd.workOrder) return;

        var sigElSel = '.k-item[data-key="{0}"]'.format(cafm.res.consts.DataKey_HelpdeskSignatures),
            sigEl = $(sigElSel),
            beforeSigCount = sigEl.data('count'),
            guid = cafm.guid.newGuid();

        var cb = function () {

            if (cafm.isMobile()) {

                cafm.hd.enableMobileWorkOrderFeatures(cafm.hd.workOrder);
                cafm.hd.setWorkOrderChildCounts(cafm.hd.workOrder);
            }
            else {

                cafm.hd.setWorkOrderChildCounts(cafm.hd.workOrder);
                cafm.forms.checkForRemovables();

                // check the selected tab is visible
                if (!$('#' + cafm.res.consts.ElementId_FormWidget).find('> ul > .k-item.k-state-active').is(':visible')) {

                    // if not switch to main details
                    cafm.forms.showFormSection(0);
                }
            }

            if (!suppressSigRefresh) {
                cafm.hd.refreshSignatures(beforeSigCount);
            }

            if (isFunc(callback)) {

                callback();
            }

            if (cafm.hd.workOrder.IsDirty) {

                cafm.hd.onWorkOrderMadeDirty();
            }

            $('#' + guid).remove();
        };

        var sel;
        var url;
        if (cafm.isMobile()) {

            cb();
        }
        else {
            
            sel = '#' + guid;
            url = 'Helpdesk/FormActions';
            body.append('<div id="{0}"></div>'.format(guid));
            $(sel).loadView({
                url: cafm.url.get(url),
                isForm: cafm.isMobile(),
                onLoad: cb
            });
        }
    },
    refreshSignatures: function (beforeSigCount) {

        // update signatures manually, if it's visible and the count has changed
        var sk = cafm.res.consts.DataKey_HelpdeskSignatures;
        var sigElSel = cafm.isMobile() ? '.cafmPbItem[data-key="{0}"]' : '.tvItem[data-key="{0}"]';
        var sigsEl = $(sigElSel.format(sk));
        var sigsCo = cafm.hd.workOrder.SignaturesCount;
        if (sigsEl.length && beforeSigCount != sigsCo) {

            if (cafm.hd.hasTabLoaded(sk)) {

                cafm.sig.refreshSignatures();
            }
            else if (cafm.isMobile()) {

                cafm.pb.displayItemCount(sigsEl, sigsCo, true);
            }
            else {

                cafm.treeView.displayItemCount(sigsEl, sigsCo, true)
            }
        }
    },
    showWorkOrderPreview: function (workOrder) {

        if (!workOrder) workOrder = cafm.hd.getWorkOrderToPreview();

        if (workOrder) {
            
            $('#rightCol .context-container').html('').loadView({
                url: cafm.url.get('Helpdesk/WorkOrderPreview/{0}'.format(workOrder.ID))
            })
        }
    },
    getWorkOrderToPreview: function (forward) {

        var woGrid = $('#{0}'.format(cafm.res.consts.ElementId_SearchGrid)).getGrid().getKendoGrid();

        if (!woGrid) {
            return null;
        }

        var workOrder, workOrders = woGrid.getSelectedRows();

        if (!cafm.util.hasItem(workOrders))
            workOrders = woGrid.dataSource.data();

        if (cafm.util.hasItem(workOrders)) {
            workOrder = workOrders[0];
        }

        return workOrder;
    }, 
    assocPropertySelected: function (e) {

        var assocProp = e.sender.getSelected();

        switch (assocProp.PropertyType) {

            case cafm.enums.AssociatedPropertyType.Tenure:

                cafm.prop.nav.showTenurePage(assocProp.PropertySummary.ID);

                break;

            case cafm.enums.AssociatedPropertyType.AsbestosElement:

                cafm.prop.nav.showAsbestosPage(assocProp.PropertySummary.ID, assocProp.PropertySummary.LocalityID);
                break;

            default:

                cafm.hd.showChildProperty(assocProp);

                break;
        }
    },
    showChildProperty: function (assocProp) {

        var actionName = cafm.enums.getEnumKey(cafm.enums.AssociatedPropertyType, assocProp.PropertyType);
        var dto = cafm.util.idData(assocProp.PropertySummary.ID)
        dto.PropertyType = assocProp.PropertyType;

        cafm.views.openActionWindow({
            url: cafm.url.get('ChildProperty/{0}'.format(actionName)),
            values: dto,
            winTitle: assocProp.PropertySummary.Description,
            initialText: cafm.res.str.TextPreparingForm,
            winOptions: {
                width: cafm.util.viewPortWidth(60),
                minHeight: 160
            }
        });
    },
    isWorkOrderDirty: function () {

        return cafm.hd.workOrder && cafm.hd.workOrder.get('IsDirty');
    },
    markWorkOrderDirty: function () {

        cafm.hd.workOrder.set('IsDirty', true);
    },
    onWorkOrderMadeDirty: function () {

        var saveButton = $('button[data-key="Save"]');

        if (!saveButton.hasClass('btnWarning')) {

            saveButton.addClass('btnWarning');
            saveButton.prepend($('<img />', {

                src: cafm.url.get('~/content/themes/default/icons/grey/1063-warning-16.png')
            }));
            saveButton.attr('title', cafm.res.str.TitleUnsavedChanges);
        }

        // hide the copy button
        cafm.hd.helpers.showHideActionButton(false, cafm.enums.WorkOrderAction.Copy);
    },
    onWorkOrderMadeUndirty: function () {

        var saveButton = $('button[data-key="Save"]');

        if (saveButton.hasClass('btnWarning')) {

            saveButton.removeClass('btnWarning');
            saveButton.find('> img').remove();
            saveButton.removeAttr('title');
        }
    },
    triggerWorkOrderDirty: function () {

        cafm.hd.markWorkOrderDirty();
        cafm.hd.onWorkOrderMadeDirty();
    },
    topLevelSearch: function () {

        var st = cafm.web.funcs.getTopSearchText();

        if (st) {

            cafm.router.loadRoute('~/Helpdesk#search/' + encodeURIComponent(st));
        }
    },
    topLevelSearchCriteria: function (criteria) {

        var st = cafm.web.funcs.getTopSearchText();

        if (st) {

            var isNum = cafm.util.isNum(st);

            if (isNum) {

                criteria.Description.Value = null;
                criteria.Reference.Value = st;
            }
            else {

                criteria.Description.Value = st;
                criteria.Reference.Value = null;
            }

            cafm.filters.setViewModel(criteria);
        }

        return criteria;
    },
    list: {

        init: function(){

        },
        showScheduleDatesFromInfo: function (d) {

            var s = [];
            var f = d.ScheduleActivityType == cafm.enums.CalendarActivityTypeData.Fixed;
            var sf = d.ScheduledFromDateTime;
            var st = d.ScheduledToDateTime;

            if (sf && st) {
                s.push('<div class="list-item-data">');
                s.push(cafm.res.str.LabelScheduleDetails);
                s.push(': ');
                if (f) s.push('<b>');
                var sameDay = cafm.util.datesAreSame(sf, st);
                var sf_out = cafm.util.toDateString(sf, 'g', '');
                var st_out = sameDay ? cafm.util.toDateString(st, 't', '') : cafm.util.toDateString(st, 'g', '');
                s.push(cafm.res.str.Template0To1.format(sf_out, st_out));
                if (f) s.push('</b>');
                s.push('</div>');
            }

            return s.join('');
        }
    },
    workOrderCachingHandler: {

        addItems: function (res) {

            var ck = cafm.res.consts.CacheKey_WorkOrders;
            var woc = cafm.cache.get(ck); // get the work order cached array            
            var items = res.Items;
            var hi = cafm.util.hasItem(items);
            var allItemIds = res.AllIds;
            cafm.hd.workOrderCachingHandler.tempAllIds = allItemIds;

            if (woc) {

                if (cafm.util.hasItem(allItemIds)) {
                    
                    // remove work orders not in the all IDs list
                    // flushes out work orders that should no longer be cached
                    cafm.util.removeWhere(woc, function (w) {

                        return allItemIds.indexOf(w.ID) == -1;
                    }); // remove existing objects not returned in the current search
                }

                if (hi) {

                    cafm.util.removeWhere(woc, function (w) {

                        return w.isInfo && cafm.util.indexOf(items, function (w2) { return w.ID == w2.ID; }) > -1;
                    }); // remove existing info objects that are returned in current the search response
                }
            }
            else {

                woc = [];
            }
            
            if (hi) {

                items.forEach(function (wo) {

                    wo.isInfo = true;
                    cafm.hd.workOrderCachingHandler.addItem(wo, woc, false); // pass in the work order cache to increase efficiency (reduces cache serlialisation/deserialisation)
                });
            }

            cafm.cache.set(ck, woc); // set the work order array in the cache
        },
        addItem: function(wo, cache, forcedAdd) {
            /// <summary>Add a work order to the cache</summary>
            /// <param name="wo" type="WorkOrderDetailData">The work order to add</param>
            /// <param name="cache" type="Object">The cache key or the cache itself, pass the cache itself when performing lots of adds to avoid execessive serialising</param>
            /// <param name="forcedAdd" type="Boolean">If the work order passed is a full object this flag when true will force the work order to be overwritten in the cache</param>

            // check for work order
            if (!wo) {

                return false;
            }

            // work order cache, need we to determine if we've been passed the cache or the string key
            var woc;
            if (isNullOrUndefined(cache)) {

                cache = wo.CacheKey;
            }

            if(isStr(cache)){

                woc = cafm.cache.get(cache); // get the work order cached array
            }
            else if (isArray(cache)) {

                woc = cache; // we've already got the work order cached array
            }
            else {

                return false; // can't add item as no cache item or key was provided 
            }

            // check the work order array exists in cache, if not create new array
            if (!isArray(woc)) {

                woc = [];
            }

            // only cache locked work orders
            if (!wo.IsLocked) {

                // ensure the unlocked work order isn't in the cache
                if (woc.length) {

                    cafm.util.removeWhere(woc, function (w) {

                        return w.ID == wo.ID;
                    });
                }
            }
            else { // if the work ordr is locked

                // check for an existing work order in the cache
                var exi;
                if (woc.length) {

                    exi = cafm.util.find(woc, function (w) {

                        return w.ID === wo.ID;
                    });
                }

                // if there's an existing work order cached
                if (exi) {

                    var exiStamp = exi.Stamp; // existing stamp
                    var newStamp = isFunc(wo.Stamp.toJSON) ? wo.Stamp.toJSON() : wo.Stamp; // new stamp

                    // force adding the object if the server object has this flag
                    if (wo.ForceClientCache) {
                        
                        // make sure the security is re-applied when there is a work order in context and we're editing
                        if (cafm.hd.workOrder && cafm.nav.isNav(cafm.enums.Navigatable.HelpdeskEditWorkOrder)) {
                            wo.Security = cafm.hd.workOrder.Security;
                        }

                        forcedAdd = true;
                    }

                    if (forcedAdd || (!cafm.util.arraysAreEqual(exiStamp, newStamp) || (!wo.isInfo && exi.isInfo))) {

                        cafm.util.removeWhere(woc, function (w) {

                            return w.ID === exi.ID;
                        }); // remove existing if the new one has a later modified date or if the new one is a full object and the existing is an info
                    }
                    else {

                        return false; // otherwise return false as the existing is a full object and not older
                    }
                }

                woc.push(wo); // push the work order into the array
            }

            if (isStr(cache)) {

                cafm.cache.set(cache, woc); // set the work order array in the cache
            }

            return true; // return true as the work order was cached
        },        
        getList: function () {

            return cafm.cache.get(cafm.res.consts.CacheKey_WorkOrders); // get the work order cached array
        },
        getItem: function (workOrderId) {

            var c = cafm.hd.workOrderCachingHandler.getList();

            if (isArray(c)) {

                return cafm.util.find(c, function (w) {

                    return w.ID == workOrderId;
                });
            }
            else {

                return null;
            }
        },
        removeItem: function(workOrderId){

            var c = cafm.hd.workOrderCachingHandler.getList();

            if (isArray(c)) {

                cafm.util.removeWhere(c, function () {

                    return c.parentId == workOrderId;
                });
            }

            cafm.cache.set(cafm.res.consts.CacheKey_WorkOrders, c);
        },
        clear: function(){
            
            cafm.cache.remove(cafm.res.consts.CacheKey_WorkOrders);
        },
        getWorkOrderChildList: function (workOrderId, childListName) {

            if (workOrderId == cafm.guid.empty) {

                workOrderId = cafm.hd.workOrder.ID;
            }

            var wo = cafm.hd.workOrderCachingHandler.getItem(workOrderId);

            return wo && wo[childListName] ? wo[childListName] : [];
        },
        cacheWorkOrderInContext: function (rebind) {

            if (cafm.hd.workOrder) {

                var wo = cafm.hd.workOrder.toJSON();

                // add the wo to the cache and force the cache set (otherwise if it isn't newer it won't overwrite the cached item if it already exists)
                cafm.hd.workOrderCachingHandler.addItem(wo, null, true);

                // rebind the work order if applicable
                if (rebind) {

                    // sets work order, binds, but doesn't cache as we've already done that in the way that forces cache update
                    cafm.hd.setWorkOrder(wo, true, true);
                }
            }
        },
        syncItems: function () {
            
            // ensure there are never two syncs going on at once
            if (cafm.hd.workOrderCachingHandler.syncTimeout) {

                clearTimeout(cafm.hd.workOrderCachingHandler.syncTimeout);
            }

            var cs = cafm.getClientSettings();
            var syncInterval = cs.offlineAutoSyncInterval * 60000;
            var doSync = function () {

                var cached = cafm.hd.workOrderCachingHandler.getList();                
                var syncItems = cafm.util.transformArray(cafm.hd.workOrderCachingHandler.tempAllIds, function (id) {

                    var cwo = cafm.util.find(cached, function (ci) {

                        return ci.ID === id;
                    });

                    return {

                        ID: id,
                        Stamp: cwo ? cwo.Stamp : null,
                        IsFullObject: cwo ? cafm.util.isTrue(cwo.IsFullObject) : false
                    }
                });

                if (cafm.util.hasItem(syncItems)) {
                    
                    if (!cs.offlineAutoSyncInterval) {

                        return false;
                    }

                    var action = cafm.hd.getSyncMyJobsAction({

                        cs: cs,
                        syncItems: syncItems,
                        refreshList: true,
                        complete: function () {

                            cafm.hd.workOrderCachingHandler.syncTimeout = null;
                            cafm.hd.workOrderCachingHandler.syncItems();
                        }
                    });
                            
                    action.execute();
                }
            };

            // if there's a configured sync interval then go ahead and sync
            if (syncInterval) {

                // if not the first time then there should be no delay
                cafm.hd.workOrderCachingHandler.syncTimeout = setTimeout(doSync, syncInterval);
            }
        },
        addSyncItems: function (syncedItems) {

            if (cafm.util.hasItem(syncedItems)) {
            
                // get the cache array to add efficiently
                var woc = cafm.hd.workOrderCachingHandler.getList();

                // add each item to the cache array
                syncedItems.forEach(function (si) {

                    // add each item
                    cafm.hd.workOrderCachingHandler.addItem(si, woc);
                });

                // set the work order array in the cache, to complete the batch operation
                cafm.cache.set(cafm.res.consts.CacheKey_WorkOrders, woc); 
            }
        }
    },
    getSyncMyJobsAction: function (e) {

        // get the action if it's there
        var a = cafm.actions.get(cafm.res.consts.ActionId_SyncMyJobs);

        if (a) {

            // return the action
            return a;
        }
        else {

            // create the action and add it to the cafm actions collection
            return cafm.actions.add(new cafm.actions.Action({
                id: cafm.res.consts.ActionId_SyncMyJobs,
                url: cafm.url.api('WorkOrder/SyncMyJobs'),
                values: e.syncItems,
                preventValidate: true,
                suppressErrors: true,
                statusCodeFuncs: {

                    200: function (r, s, m, action) {

                        // add the sync items
                        cafm.hd.workOrderCachingHandler.addSyncItems(r);

                        // refresh list if flagged to do so
                        if (e.refreshList) {

                            $('#' + cafm.res.consts.ElementId_SearchList).refreshListDS();
                        }
                    }
                },
                complete: function () {

                    if (isFunc(e.complete)) {

                        e.complete();
                    }
                }
            }));
        }
    },
    getWorkOrderInContext: function (e) {

        cafm.hd.getWorkOrderInContextAction(e).execute();
    },
    getWorkOrderInContextAction: function (e) {

        var woid = e.workOrderId ? e.workOrderId : cafm.guid.empty;
        var wurl = cafm.url.api('WorkOrder/GetWorkOrderInContext/{0}', woid);

        // get the action if it's there
        var a = cafm.actions.get(cafm.res.consts.ActionId_GetWorkOrder);

        if (a) {

            a.set('url', wurl);

            // return the action
            return a;
        }
        else {

            var csoe = cafm.getClientSettings().offlineEnabled;

            // create the action and add it to the cafm actions collection
            return cafm.actions.add(new cafm.actions.Action({
                id: cafm.res.consts.ActionId_GetWorkOrder,
                method: 'GET',
                url: wurl,
                elementId: cafm.res.consts.ElementId_MainForm,
                loaderSelector: '#' + cafm.res.consts.ElementId_MainForm,
                preventValidate: true,
                statusCodeFuncs: {

                    200: function (r, s, m, action) {

                        // use the callback parameter to perform logic after getting the work order
                        var cb = e.callback;
                        if (isObj(r) && r.IsFullObject && isFunc(cb)) {

                            if (csoe) {
                                cafm.setOffline(false);
                                cafm.views.hideOfflineMessage();
                            }

                            cb(r); // call the callback function and pass the work order
                        }
                    }
                },
                complete: function (r, s, m, action) {

                    // when we don't get the work order object and it's not a 500, assume offline
                    if (csoe && r.status != 500 && (!isObj(r.responseJSON) || !r.responseJSON.IsFullObject)) {

                        cafm.setOffline(true);
                        cafm.views.showOfflineMessage();
                        cafm.hd.helpers.showWorkOrderNoSyncMessage();
                    }
                }
            }));
        }
    },
    ensureWorkOrderInContext: function (e) {

        cafm.hd.getEnsureWorkOrderInContextAction(e).execute();
    },
    getEnsureWorkOrderInContextAction: function (e) {
        
        // get the action if it's there
        var a = cafm.actions.get(cafm.res.consts.ActionId_EnsureWorkOrder);

        if (a) {

            a.set('cachedWorkOrder', e.workOrder);
            
            a.set('values', {

                ID: e.workOrder.ID,
                Stamp: e.workOrder.Stamp
            })

            // return the action
            return a;
        }
        else {

            // use the callback parameter to perform logic after getting the work order
            var cb = e.callback;

            // create the action and add it to the cafm actions collection
            return cafm.actions.add(new cafm.actions.Action({
                id: cafm.res.consts.ActionId_EnsureWorkOrder,
                url: cafm.url.api('WorkOrder/EnsureWorkOrderInContext'),
                elementId: cafm.res.consts.ElementId_MainForm,
                loaderSelector: '#' + cafm.res.consts.ElementId_MainForm,
                preventValidate: true,
                suppressErrors: true,
                cachedWorkOrder: e.workOrder,
                values: {

                    ID: e.workOrder.ID,
                    Stamp: e.workOrder.Stamp
                },
                statusCodeFuncs: {

                    // 200 handles a valid ensured work order coming back
                    // 304 is returned when the cached work order is valid and we don't need to do anything
                    200: function (r, s, m, action) {

                        if (isFunc(cb)) {

                            cb(r); // call the calback function and pass the work order
                        }
                    }
                },
                complete: function (r, s, m, action) {

                    // handle 304 here as 304 status func doesn't get handled but this does
                    // when offline we get a 404 so we handle that here too
                    if ([304,404,0].indexOf(r.status) > -1) {
                        
                        if (isFunc(cb)) {

                            var cacheWo = action.get('cachedWorkOrder');
                            if (cacheWo) {
                                cb(cacheWo); // call the callback function and pass the cached work order
                            }
                            else {
                                cafm.hd.helpers.showWorkOrderNoSyncMessage();
                            }
                            action.hideLoader();
                        }
                    }
                }
            }));
        }
    },
    enablePermissibleFeatures: function (e) {

        var url;
        if (e.url) {

            url = e.url;

            var mainFormVm = cafm.views.getMainFormViewModel();

            if(isNullOrUndefined(mainFormVm)){

                mainFormVm = cafm.views.getMainFormViewModel('.bindTarget:first');
            }

            if (mainFormVm) {

                url += ('/' + mainFormVm.ID);
            }
        }
        else {

            return;
        }

        cafm.enablingPermissibleFeatures = true;

        cafm.actions.getResponseObject({
            url: url,
            suppressErrors: true,
            timeout: cafm.res.consts.Var_GetPermissionsTimeout,
            callback: function (p) {

                e.callback(p);
            },
            fallback: e.fallback,
            complete: function() {
                
                delete cafm.enablingPermissibleFeatures;
                cafm.forms.checkForRemovables();
            },
            sync: false
        })
    },
    enableWorkOrderFeatures: function (p) {
  
        if (p.Actions) {

            for (var k in p.Actions) {

                if(isStr(k) && p.Actions[k] === true){

                    $('[data-key="{0}"]'.format(k)).removeAttr('data-notallowed').removeClass('hidden').show();
                }
                else {

                    $('[data-key="{0}"]'.format(k)).attr('data-notallowed', true).hide();
                }
            }
            cafm.toolbar.helpers.ensureToolbarDisplay();
        }

        if (p.Features) {

            for (var k in p.Features) {

                var el = $('[data-key="{0}"]'.format(k));

                if (isStr(k) && p.Features[k] === true) {

                    el.removeClass('hidden').filter('.k-item').show();
                }
                else {

                    el.addClass('hidden');
                }
            }
        }

        if (!isMobile) {

            $('#' + cafm.res.consts.ElementId_FormWidget).trigger('resize');
        }
    },
    setWorkOrderChildCounts: function (workOrder) {

        var s = isMobile ? '[data-key="{0}"]' : '#formWidget > .k-tabstrip-items > [data-key="{0}"]';

        // action checklists
        cafm.hd.setWorkOrderChildCount($(s.format(cafm.res.consts.DataKey_HelpdeskActionChecklists)), workOrder.ActionChecklistCount);

        // assets
        cafm.hd.setWorkOrderChildCount($(s.format(cafm.res.consts.DataKey_HelpdeskAssets)), workOrder.AssetsCount);

        // asset meters
        cafm.hd.setWorkOrderChildCount($(s.format(cafm.res.consts.DataKey_AssetMeters)), workOrder.AssetMetersCount);

        // costs
        cafm.hd.setWorkOrderChildCount($(s.format(cafm.res.consts.DataKey_HelpdeskCosts)), workOrder.CostsCount);

        // customer risk assessments
        cafm.hd.setWorkOrderChildCount($(s.format(cafm.res.consts.DataKey_HelpdeskCustomerRiskAssessments)), workOrder.CustomerRiskAssessmentsCount);
        
        // documents
        cafm.hd.setWorkOrderChildCount($(s.format(cafm.res.consts.DataKey_Documents)), workOrder.DocumentsCount);

        // events
        cafm.hd.setWorkOrderChildCount($(s.format(cafm.res.consts.DataKey_HelpdeskEventLog)), workOrder.EventsCount);

        // labour charges
        cafm.hd.setWorkOrderChildCount($(s.format(cafm.res.consts.DataKey_HelpdeskLabourCharges)), workOrder.LabourChargesCount);

        // notes
        cafm.hd.setWorkOrderChildCount($(s.format(cafm.res.consts.DataKey_Notes)), workOrder.NotesCount);

        // parts
        cafm.hd.setWorkOrderChildCount($(s.format(cafm.res.consts.DataKey_HelpdeskStock)), workOrder.StocksCount);

        // properties
        cafm.hd.setWorkOrderChildCount($(s.format(cafm.res.consts.DataKey_HelpdeskProperties)), workOrder.PropertiesCount);

        // risk assessments
        cafm.hd.setWorkOrderChildCount($(s.format(cafm.res.consts.DataKey_HelpdeskRiskAssessmentChecklists)), workOrder.RiskAssessmentChecklistCount);

        // signatures
        cafm.hd.setWorkOrderChildCount($(s.format(cafm.res.consts.DataKey_HelpdeskSignatures)), workOrder.SignaturesCount);

        // trade person risk assessments
        cafm.hd.setWorkOrderChildCount($(s.format(cafm.res.consts.DataKey_HelpdeskTradePersonRiskAssessments)), workOrder.TradePersonRiskAssessmentsCount);

        // travel
        cafm.hd.setWorkOrderChildCount($(s.format(cafm.res.consts.DataKey_HelpdeskTravel)), workOrder.TravelCount);
    },
    setWorkOrderChildCount: function(element, count, isPb){

        if (!isNum(count)) {

            count = 0;
        }

        // is mobile or is desktop but also a panel bar
        if (cafm.isMobile() || isPb) {

            cafm.pb.displayItemCount(element, count);
        }
        else {

            cafm.tab.displayItemCount(element, count);
            //cafm.treeView.displayItemCount(element, count);
        }
    },
    getWorkOrderChildList: function (cln) {
        
        var w = cafm.hd.workOrder;
        return w && w[cln] ? w[cln] : [];
    },
    enableMobileWorkOrderFeatures: function (workOrder) {

        // enable work order features and actions

        // the fallback security handler for when offline
        var wsFallback = function (ws) {

            // if there is a security object then enable offline work order features
            if (ws) {

                cafm.hd.enableWorkOrderFeatures({
                    Features: {
                        AssetMeters: ws.Features.AssetMeters === true && cafm.util.hasItem(workOrder.AssetMeters),
                        HelpdeskAssets: ws.Features.HelpdeskAssets,
                        HelpdeskCosts: ws.Features.HelpdeskCosts,
                        HelpdeskLabourCharges: ws.Features.HelpdeskLabourCharges,
                        HelpdeskActionChecklists: ws.Features.HelpdeskActionChecklists,
                        HelpdeskRiskAssessmentChecklists: ws.Features.HelpdeskRiskAssessmentChecklists,
                        HelpdeskStock: ws.Features.HelpdeskStock,
                        HelpdeskTravel: ws.Features.HelpdeskTravel,
                        Notes: ws.Features.Notes
                    },
                    Actions: {
                        Accept: false,
                        Complete: hdActions.offlineSecurity.isAllowed(cafm.enums.LogWorkOrderAction.Complete),
                        CompleteLabourCharge: hdActions.offlineSecurity.isAllowed(cafm.enums.LogWorkOrderAction.CompleteLabourCharge),
                        Copy: false,
                        Decline: false,
                        Discard: false,
                        Email: false,
                        EndTask: false,
                        ExtendOnHold: false,
                        Issue: false,
                        PlaceOnHold: hdActions.offlineSecurity.isAllowed(cafm.enums.LogWorkOrderAction.PlaceOnHold),
                        Print: false,
                        ResetStatus: false,
                        Resolve: hdActions.offlineSecurity.isAllowed(cafm.enums.LogWorkOrderAction.Resolve),
                        Save: false,
                        Start: hdActions.offlineSecurity.isAllowed(cafm.enums.LogWorkOrderAction.Start),
                        StartLabourCharge: hdActions.offlineSecurity.isAllowed(cafm.enums.LogWorkOrderAction.StartLabourCharge),
                        TakeOffHold: hdActions.offlineSecurity.isAllowed(cafm.enums.LogWorkOrderAction.TakeOffHold),
                        AddNote: hdActions.offlineSecurity.isAllowed(cafm.enums.LogWorkOrderAction.AddNote),
                        EditNote: hdActions.offlineSecurity.isAllowed(cafm.enums.LogWorkOrderAction.EditNote),
                        Unlock: false
                    }
                });

                $('#sub-header-toolbar .action-buttons').removeClass("button-group-overflow-init");
            }
        }

        // if offline is known already don't attempt the work order permissions call
        if (cafm.isOffline()) {

            // enable work order offline features
            wsFallback(workOrder.Security);
        }
        else {
                        
            // otherwise go to the server and attempt to get the permissions
            cafm.hd.enablePermissibleFeatures({

                url: cafm.url.api('WorkOrderSecurity/GetWorkOrderPermissions'),
                callback: function (ws) {

                    // put the security on the work order, that way a fully synced work order will always have it's own permissions
                    // note this will always have to happen before setWorkOrder is called
                    // the security is set here as client-side security is currently of no use to the desktop rendering mode
                    // may change this later when there is time to change all of the work order form
                    workOrder.Security = ws;

                    // now cache the work order
                    cafm.hd.workOrderCachingHandler.addItem(workOrder, null, true);

                    // enable work order features
                    cafm.hd.enableWorkOrderFeatures(ws);

                    $('#sub-header-toolbar .action-buttons').removeClass("button-group-overflow-init");
                },
                fallback: function () {

                    // enable work order offline features
                    wsFallback(workOrder.Security);
                }
            });
        }
    },
    logOutHandle: function () {

        var cs = cafm.getClientSettings();

        if (cs.offlineEnabled) {

            cafm.hd.workOrderCachingHandler.clear();
        }
    },
    isWorkOrderLocalityEqual: function (w1, w2) {

        if (!(w1 || w2 || w1.LocalityDescription || w2.LocalityDescription)) {

            return false;
        }

        return w1.ForLocalityID == w2.ForLocalityID;
    },
    handlers: {

        assetsChanged: function (workOrder) {
            /// <summary>Event handler for when an asset is added or removed</summary>
            /// <param name="workOrder" type="Object">Work Order object</param>
            cafm.hd.childActionPerformed(workOrder);
            cafm.hd.checklist.helpers.removeWorkOrderViewKeys();
            cafm.hd.helpers.removeDocumentsViewKey();
            cafm.hd.removeTabLoadKey(cafm.res.consts.DataKey_AssetMeters);
            cafm.hd.refreshNavigation();
        },
        assignmentsChanged: function (workOrder) {
            /// <summary>Event handler for when an assignment is added or removed</summary>
            /// <param name="workOrder" type="Object">Work Order object</param>

            cafm.hd.childActionPerformed(workOrder, false);
            cafm.hd.removeTabLoadKey(cafm.res.consts.DataKey_HelpdeskLabourCharges);
            cafm.hd.removeTabLoadKey(cafm.res.consts.DataKey_HelpdeskDocuments);
            cafm.hd.helpers.removeDocumentsViewKey();
            cafm.hd.refreshNavigation();

            // TODO: get the ensure default values working...
            $('#serviceProviderPlc').refreshForm().find('[data-default]').ensureDefaultValues();
        },
        documentsChanged: function (workOrder) {
            /// <summary>Event handler for when a document is added or removed</summary>
            /// <param name="workOrder" type="Object">Work Order object</param>

            cafm.hd.childActionPerformed(workOrder);
            cafm.docs.refreshAttachments();
        },
        localityChanged: function (e) {
            /// <summary>Event handler for when locality is changed</summary>
            /// <param name="e" type="Object">Locality object</param>

            var fieldName = 'LocalityDescription';

            cafm.hd.addSyncAction(function (syncId) {

                cafm.hd.callWoGuidSyncAction('SetForLocalityID', cafm.hd.workOrder.get('ID'), e.val, fieldName, syncId, true);
                cafm.hd.checklist.helpers.removeWorkOrderViewKeys();
                cafm.hd.helpers.removeDocumentsViewKey();
                cafm.forms.showFormSection(0);
            }, fieldName);


        },
        tradeFilterChanged: function (args) {
            /// <summary>Handler function for the multiple trade lookup filter</summary>
            /// <param name="args" type="Object">Lookup event args object</param>
            
            cafm.hd.helpers.filterTradeFilterTypes($(args.currentTarget).data('items'));
        }
    },
    helpers: {

        applyMinLocalityLevel: function (workOrder) {
            /// <summary>Helper to apply the minimum locality level to work order for locality text searching functionality</summary>
            /// <param name="workOrder" type="Object">Current work order</param>
            
            // set min locality level on for locality text search locality type filter
            if (workOrder.MinimumLocalityLevel > 1) {

                var applyMinLocLev = function (wrapper) {

                    var items = wrapper.find('li');
                    if (items.length) {

                        var ltf = 0;
                        // loop each item and uncheck / disable as appropriate
                        items.each(function (i, li) {

                            li = $(li);
                            var cbox = li.find('[type=checkbox]');

                            if (workOrder.MinimumLocalityLevel < cbox.data('value')) {

                                cbox.setChecked(false, true).setCheckboxDisabled(true);
                            }
                            else if (cbox.isChecked()) {

                                ltf += cbox.data('value');
                            }
                        });

                        wrapper.find('.' + cafm.res.consts.CssClass_LookupInput).setAutoCompleteFilter('LocalityType', ltf);
                    }
                }

                applyMinLocLev($('#forLocalityPlc'));
                applyMinLocLev($('#toLocalityPlc'));
            }
        },
        applyRecentWorkOrdersMessage: function (workOrder) {
            /// <summary>Helper to apply the recent work order message to the work order messages</summary>
            /// <param name="workOrder" type="Object">Current work order</param>

            // process any recent work orders matching locality
            if (cafm.util.hasItem(workOrder.RecentWorkOrders)) {

                if (!workOrder.Messages) workOrder.Messages = [];
                
                var revDays = cafm.getClientSettings().helpdeskSettings.woDaysToReviewExisting,
                    title = cafm.res.str.TemplateRecentWorkOrders.dataFormat({
                        WorkOrderCount: workOrder.RecentWorkOrders.length,
                        WorkOrderLabel: workOrder.RecentWorkOrders.length == 1 ? cafm.res.str.LabelWorkOrder : cafm.res.str.LabelWorkOrders,
                        DayLabel: revDays <= 1 ? cafm.res.str.LabelDay : (revDays + ' ' + cafm.res.str.LabelDays),
                        LocalityDescription: '{0}: {1}'.format(cafm.enums.getEnumKey(cafm.enums.LocalityTypeData, workOrder.LocalityDescription.LocalityType), workOrder.LocalityDescription.LocalityDescription)
                    });
                
                cafm.hd.handlers.viewRecentWorkOrders = function (e) {

                    if (cafm.isMobile()) {
                        $(e.currentTarget).closest('.msgPnl').find('.msgTxt').toggle(250);
                    }
                    else {
                        cafm.views.openActionWindow({
                            url: cafm.url.get('Helpdesk/RecentWorkOrderGrid'),
                            method: 'GET',
                            winOptions: {
                                width: cafm.util.viewPortWidth(80),
                                height: 442,
                                title: title
                            },
                            onLoad: function (element, win) {

                                // format the data
                                cafm.hd.onWoInfoDataRetrieved(workOrder.RecentWorkOrders);
                                // show grid, set data
                                $('#recentWorkOrderGrid .cGrd').show().getDataSource().data(workOrder.RecentWorkOrders);
                            }
                        });
                    }
                };

                var msg = {
                        title: title,
                        cssClass: 'recent-wo-msg',
                        link: {
                            text: cafm.res.str.LabelViewRecentWorkOrders,
                            click: !cafm.isMobile() ? 'cafm.hd.handlers.viewRecentWorkOrders' : null // has to be a string, otherwise it won't get through some cloning in the message panel script
                        }
                    };

                if (cafm.isMobile()) {

                    var details = [];
                    workOrder.RecentWorkOrders.forEach(function (recentWorkOrder) {

                        details.push('<span class="msgTxtLine">{0}&nbsp;{1}&nbsp;{2}</span>'.format(cafm.hd.formatLcs(recentWorkOrder.LifeCycleStatus, true), recentWorkOrder.Reference, recentWorkOrder.Description ? recentWorkOrder.Description.trim().split('\n')[0] : ''));
                    });
                    msg.html = details.join('');
                    msg.hideDetails = true;
                    msg.allowDetailToggle = true;
                }

                cafm.util.removeWhere(workOrder.Messages, function (m) { return m.cssClass == msg.cssClass });
                workOrder.Messages.unshift(msg);
            }
        },
        filterTradeFilterTypes: function (selectedTrades) {
            /// <summary>Helper function to filter trade filter types based on selected trades</summary>
            /// <param name="selectedTrades" type="Array">Selected trades array</param>

            var tradeFilterEl = $('#TradeFilter'),
            tradeFilterKd = tradeFilterEl.data('kendoDropDownList'),
            dataItems = cafm.util.addAll([], tradeFilterEl.data('items')), toInclude;

            // if there's no kendo dropdown yet then exit, not possible yet
            if (!tradeFilterKd) return;

            // if there's no selected trades then filter down the trade type filter dropdown items
            if (!cafm.util.hasItem(selectedTrades)) {

                toInclude = [cafm.enums.FilterTrade.All, cafm.enums.FilterTrade.Unassigned, cafm.enums.FilterTrade.Assigned];

            }
            else {

                toInclude = [cafm.enums.FilterTrade.All, cafm.enums.FilterTrade.ToAction, cafm.enums.FilterTrade.Unassigned, cafm.enums.FilterTrade.Assigned, cafm.enums.FilterTrade.Principal, cafm.enums.FilterTrade.Historic];
            }

            if (toInclude) {
                                
                cafm.util.removeWhere(dataItems, function (item) {

                    return !cafm.util.arrayContains(toInclude, parseInt(item.value));
                });
            }

            var currentVal = tradeFilterKd.value();

            // set the dropdown datasource with filtered or unfiltered items
            tradeFilterKd.setDataSource(new kendo.data.DataSource({
                data: dataItems
            }));

            // get the parent view model and ensure the correct option is selected
            var pvm = tradeFilterEl.getParentViewModel();

            // if item does not exist in items reset to all
            if (!cafm.util.exists(dataItems, function (item) { return item.value == currentVal; })) {

                pvm.set('TradeFilter', cafm.enums.FilterTrade.All);
            }

            // ensure dropdown selection
            tradeFilterKd.value(pvm.TradeFilter);
        },
        getAllTradePeopleForWorkOrder: function (workOrder) {
            /// <summary>Gets the trade people for a work order</summary>
            /// <param name="workOrder" type="Object">Work Order object</param>
            /// <returns type="Array">Array of trade people</returns>
            
            var tradePpl = cafm.hd.workOrder.TradePeople ? cafm.hd.workOrder.TradePeople.toJSON() : [],
            historicTradePpl = cafm.hd.workOrder.HistoricTradePeople ? cafm.hd.workOrder.HistoricTradePeople.toJSON() : [];

            // historic if there are any
            if (cafm.util.hasItem(historicTradePpl)) {

                cafm.util.addAll(tradePpl, historicTradePpl);
            }

            // filter out viewers
            tradePpl = cafm.util.where(tradePpl, function (tp) {

                return tp.ResponsibilityType != cafm.enums.PersonResponsibilityType.Viewer;
            });

            // sort the trade people by full name
            tradePpl.sort(function (a, b) {
                var aTxt = a.FullName.toLowerCase();
                var bTxt = b.FullName.toLowerCase();
                if (aTxt < bTxt) return -1;
                if (aTxt == bTxt) return 0;
                return 1;
            });

            return tradePpl;
        },
        getDefaultChargeRate: function (workOrder) {
            /// <summary>Gets the default charge rate for the current person if they are assigned as a trade person</summary>
            /// <param name="workOrder" type="Object">Work Order object</param>
            /// <returns type="String">Default charge rate code or string equal to Guid.Empty</returns>

            // if no person record then just return empty
            if (cafm.auth.isAnonGuest()) return cafm.guid.empty;

            // person id
            var pid = cafm.auth.personId();

            // get the trade person from the work order
            // will be null if not assigned
            var tradePerson = cafm.util.find(workOrder.TradePeople, function (tp) {

                return tp.ID == pid;
            });

            // if there's no match try to get historic - this is for end task
            if (!tradePerson) {

                tradePerson = cafm.util.find(workOrder.HistoricTradePeople, function (tp) {

                    return tp.ID == pid;
                });
            }

            // if there is a matched trade person return the charge rate code ID
            if (tradePerson) {

                return {
                    ID: tradePerson.ChargeRateCodeID,
                    Description: tradePerson.ChargeRateCodeDescription
                }
            }
            else {

                // otherwise return null
                return null;
            }
        },
        getTradePeopleForWorkOrder: function (workOrder) {
            /// <summary>Gets the trade people for a work order</summary>
            /// <param name="workOrder" type="Object">Work Order object</param>
            /// <returns type="Array">Array of trade people</returns>

            var tradePpl = cafm.hd.workOrder.TradePeople.toJSON();

            // filter out viewers
            tradePpl = cafm.util.where(tradePpl, function (tp) {

                return tp.ResponsibilityType != cafm.enums.PersonResponsibilityType.Viewer;
            });
            
            // sort the trade people by full name
            tradePpl.sort(function (a, b) {
                var aTxt = a.FullName.toLowerCase();
                var bTxt = b.FullName.toLowerCase();
                if (aTxt < bTxt) return -1;
                if (aTxt == bTxt) return 0;
                return 1;
            });

            return tradePpl;
        },
        isContractor: function () {
            /// <summary>Determines if the current user has the engineer or team leader role</summary>
            /// <returns type="Boolean">Returns true or false</returns>

            return cafm.hd.role == cafm.enums.RoleType.CAFMWebContractor;
        },
        isEndUser: function () {
            /// <summary>Determines if the current user has the engineer or team leader role</summary>
            /// <returns type="Boolean">Returns true or false</returns>

            return cafm.enums.isSingleEnumValue(cafm.hd.role, [cafm.enums.RoleType.CAFMWebEndUserHelpdeskBasic, cafm.enums.RoleType.CAFMWebEndUserHelpdeskAdvanced_Two, cafm.enums.RoleType.CAFMWebEndUserHelpdeskAdvanced_One]);
        },
        isAnyEngineer: function () {
            /// <summary>Determines if the current user has the engineer or team leader role</summary>
            /// <returns type="Boolean">Returns true or false</returns>

            return cafm.enums.isSingleEnumValue(cafm.hd.role, [cafm.enums.RoleType.CAFMWebEngineer, cafm.enums.RoleType.CAFMWebEngineerTeamLeader]);
        },
        isAssignedOrTeamLeadForWorkOrder: function (workOrder) {
            /// <summary>Determines if the current user is principal, assistant or team lead for a work order</summary>
            /// <param name="workOrder" type="Object">Work Order object</param>
            /// <returns type="Boolean">Returns true or false</returns>

            var valid = cafm.hd.helpers.isPrincipalOrAssistantForWorkOrder(workOrder);

            if (!valid) {

                valid = cafm.hd.helpers.isTeamLeadForWorkOrder(workOrder);
            }

            return valid;
        },

        isHelpdeskOperator: function () {
            /// <summary>Determines if the current user has the helpdesk basic or helpdesk advanced role</summary>
            /// <returns type="Boolean">Returns true or false</returns>

            return cafm.enums.isSingleEnumValue(cafm.hd.role, [cafm.enums.RoleType.CAFMWebHelpdeskBasic, cafm.enums.RoleType.CAFMWebHelpdeskAdvanced]);
        },
        isPrincipalForWorkOrder: function (w) {
            /// <summary>Determines if the current user is principal for a work order</summary>
            /// <param name="w" type="Object">Work Order object</param>
            /// <returns type="Boolean">Returns true or false</returns>

            if (w && cafm.util.hasItem(w.TradePeople) && cafm.hd.helpers.isAnyEngineer()) {

                var pid = cafm.auth.personId();
                return cafm.util.exists(w.TradePeople, function (tp) {

                    return tp.IsPrincipal && tp.ID == pid;
                });
            }

            return false;
        },
        isPrincipalOrAssistantForWorkOrder: function (w) {
            /// <summary>Determines if the current user is principal or assistant for a work order</summary>
            /// <param name="w" type="Object">Work Order object</param>
            /// <returns type="Boolean">Returns true or false</returns>

            if (w && cafm.util.hasItem(w.TradePeople) && cafm.hd.helpers.isAnyEngineer()) {

                var pid = cafm.auth.personId();
                return cafm.util.exists(w.TradePeople, function (tp) {

                    return (tp.IsPrincipal || tp.IsAssistant) && tp.ID == pid;
                });
            }

            return false;
        },
        isPrincipalOrTeamLeadForWorkOrder: function (workOrder) {
            /// <summary>Determines if the current user is principal or team lead for a work order</summary>
            /// <param name="workOrder" type="Object">Work Order object</param>
            /// <returns type="Boolean">Returns true or false</returns>

            var valid = cafm.hd.helpers.isPrincipalForWorkOrder(workOrder);

            if (!valid) {

                valid = cafm.hd.helpers.isTeamLeadForWorkOrder(workOrder);
            }

            return valid;
        },
        isTeamLeadForWorkOrder: function (workOrder) {
            /// <summary>Determines if the current user is team lead for a work order</summary>
            /// <param name="workOrder" type="Object">Work Order object</param>
            /// <returns type="Boolean">Returns true or false</returns>

            var tradeIds = cafm.getClientSettings().currentPersonTradeIds;

            return cafm.hd.role == cafm.enums.RoleType.CAFMWebEngineerTeamLeader && cafm.util.exists(workOrder.Trades, function (t) {

                return cafm.util.arrayContains(tradeIds, t.TradeCodeID);
            })
        },
        isTradePersonForWorkOrder: function (w) {
            /// <summary>Determines if the current user is principal, assistant or historic for a work order</summary>
            /// <param name="w" type="Object">Work Order object</param>
            /// <returns type="Boolean">Returns true or false</returns>

            if (w && cafm.util.hasItem(w.TradePeople)) {

                var pid = cafm.auth.personId();
                return cafm.util.exists(w.TradePeople, function (tp) {

                    return tp.ID == pid;
                });
            }

            return false;
        },
        isHistoricTradePersonForWorkOrder: function (w) {
            /// <summary>Determines if the current user is a historic trade person for the work order</summary>
            /// <param name="w" type="Object">Work Order object</param>
            /// <returns type="Boolean">Returns true or false</returns>

            if (w && cafm.util.hasItem(w.HistoricTradePeople)) {

                var pid = cafm.auth.personId();
                return cafm.util.exists(w.HistoricTradePeople, function (tp) {

                    return tp.ID == pid;
                });
            }

            return false;
        },
        isWorkOrderFinal: function (w) {
            /// <summary>Determines if the work order is either completed or discarded</summary>
            /// <param name="w" type="Object">Work Order object</param>
            /// <returns type="Boolean">Returns true or false</returns>

            return cafm.enums.isSingleEnumValue(w.LifeCycleStatus, [cafm.enums.LifeCycleStatus.Completed, cafm.enums.LifeCycleStatus.Discarded]);
        },
        refreshWorkOrderToolbar: function (tbar) {
            window.SubHeaderContainer.setToolbar(tbar);
        },
        removeDocumentsViewKey: function () {
            /// <summary>Removes document tab loaded key</summary>

            cafm.hd.removeTabLoadKey(cafm.res.consts.DataKey_Documents);
        },
        renderWoInfoLocality: function (data) {
            
            var v = cafm.util.encodeHtml(cafm.hi.localityTrailFromInfo(data));
            if (!cafm.nav.isNav(cafm.enums.Navigatable.HelpdeskNewLocalitySearch) && cafm.util.guidHasValue(data.ForLocalityID)) {

                return '<a class="list-item-data" href="\#newSearchByLocality/{0}">{1}</a>'.format(data.ForLocalityID, v);
            }
            else {

                return '<div class="list-item-data">{0}</div>'.format(v);
            }
        },
        renderInternalResponseDateTime: function (data, label) {

            var v = data.InternalRequiredResponseDateTime || data;
            if (v) {
                if (cafm.nav.isNav(cafm.enums.Navigatable.HelpdeskMyJobs) && v < cafm.web.funcs.getNowUTC()) {
                    v = cafm.util.toDateString(v, 'g');
                    return isMobile ? '<div class="list-item-data">{0}: <span class="woInfoOverdue">{1}</span></div>'.format(cafm.util.encodeHtml(label), v) : '<span class="woInfoOverdue">{0}</span>'.format(v);
                }
                else {
                    v = cafm.util.toDateString(v, 'g');
                    return isMobile ? '<div class="list-item-data">{0}: {1}</div>'.format(cafm.util.encodeHtml(label), v) : v;
                }
            }
        },
        renderInternalFixDateTime: function(data, label) {

            var v = data.InternalRequiredFixDateTime || data;
            if (v) {
                if (cafm.nav.isNav(cafm.enums.Navigatable.HelpdeskMyJobs) && v < cafm.web.funcs.getNowUTC()) {
                    v = cafm.util.toDateString(v, 'g');
                    return isMobile ? '<div class="list-item-data">{0}: <span class="woInfoOverdue">{1}</span></div>'.format(cafm.util.encodeHtml(label), v) : '<span class="woInfoOverdue">{0}</span>'.format(v);
                }
                else {
                    v = cafm.util.toDateString(v, 'g');
                    return isMobile ? '<div class="list-item-data">{0}: {1}</div>'.format(cafm.util.encodeHtml(label), v) : v;
                }
            }
        },
        toDateTimeHtml(dt)
        {
            dt = cafm.util.toDateString(dt, 'g', '');
            return isMobile ? '<div class="list-item-data">{0}: {1}</div>'.format(cafm.util.encodeHtml(label), dt) : dt;
        },
        setupTradeTypeFilter: function () {
            /// <summary>Helper function to setup trade type filter</summary>
            
            var lookupList = $('#TradeCodePairsFilter .cfLookupList');

            // filter event function to attach trade filter type specific behaviour
            var filterFunc = function (args, criteria) {
                
                if (!args || args.field != 'TradeFilter') {

                    cafm.hd.helpers.filterTradeFilterTypes(lookupList.data('items'));
                }
            };

            // register filter events
            cafm.filters.registerOnFiltersReady(filterFunc);
            cafm.filters.registerOnCriteriaChanged(filterFunc);
        },
        showHideActionButton: function (visible) {
            /// <summary>Helper function to show or hide the work order action buttons</summary>
            /// <param name="visible" type="Boolean">Show or hide flag</param>

            var formatTemplate = '[data-key="{0}"]', selector = [];

            if (arguments.length) {

                for (var i = 1; i < arguments.length; i++) {

                    var key = cafm.enums.getEnumKey(cafm.enums.WorkOrderAction, arguments[i]);

                    if (key) {

                        selector.push(formatTemplate.format(key));
                    }
                }
            }
            else {

                return;
            }

            var btn = $(selector.join(','));

            if (visible) {

                btn.show();
            }
            else {

                btn.removeAttr("data-moved").hide();
            }

            if ($(".search-action-buttons").length)
                cafm.toolbar.helpers.ensureToolbarDisplay();
        },
        showWorkOrderNoSyncMessage: function () {

            // hide the toolbar area
            $('#{0}, #sub-header'.format(cafm.res.consts.ElementId_FormWidget)).hide();

            // show work order not synced message
            $('#mainContentPane').showMessage({
                title: cafm.res.str.MessageWorkOrderNotSynced,
                type: cafm.enums.MessageType.Warning
            });

            // show the back button
            $('#backBtn').show();
        },
        sourceDescription: function (source) {
            /// <summary>Helper function to show work order source description</summary>
            /// <param name="source" type="Number">Source int/enum value</param>
            /// <returns type="String">Source description</param>

            var s;

            switch(source)
            {
                case cafm.enums.WorkOrderSource.Planned:

                    s = cafm.res.str.LabelPlanned;
                    break;

                case cafm.enums.WorkOrderSource.Reactive:

                    s = cafm.res.str.LabelReactive;
                    break;

                default:

                    s = '';
                    break;
            }

            return cafm.util.encodeHtml(s);
        },
        changeAdditionalDescription: function (currencySymbol, changedCurrencySymbol) {
            var additionalDescription = $(".elementStateDesc").text();
            var changedDesc = additionalDescription.replace(currencySymbol, changedCurrencySymbol);
            if (changedDesc) {
                var descEl = $('.elementStateDesc');
                if (!descEl.length) {

                    descEl = $('<span />', {
                        'class': 'elementStateDesc'
                    }).appendTo($('#woAdditionalCollapser'));
                }
                descEl.html('&nbsp;{0}'.format(changedDesc));
            }
        }
    }
}